export const UserLoginMessage = {
  LogginFailure: "Login Failed. Incorrect Email and Password.",
  LogginSuccess: "User logged in",
  LoginEmailBlank: "Enter Email Address",
  LoginPasswordBlank: "Enter Password",
  LoginInvalidEmail: "Enter valid Email",
  InactiveAbstractor: `Your account is inactive. Please contact the administrator at <u><a href="mailto:emmpower@analysisgroup.com">emmpower@analysisgroup.com</a></u> for further assistance.`,
  reCAPTCHAFail: "reCAPTCHA validation failed. Please try again.",
};
export const Abstractor_Msgs = {
  FIRSTNAME: "Enter first name",
  LASTNAME: "Enter last name",
  EMAIL_REQUIRED: "Enter email address",
  EMAIL_VALID: "Please enter a valid email",
  CENTER: "Please select center",
  REQUIRED: "This field is required",
  PASSWORD_VALID:
    "Your password must contain one lowercase letter, one uppercase letter, one number, and one symbol",
  EMAIL_EXISTS: "Email address already exists",
  CENTER_LOAD_ERROR: "Error occurred while loading centers",
  ADD_SUCCESS: "Abstractor added successfully",
  EDIT_SUCCESS: "Abstractor updated successfully",
  DELETE_SUCCESS: "Abstractor deleted successfully",
  DELETE_FAIL: "Error occurred when deleting abstractor",
  EMAIL_SENDOUT_SUCCESS: "Email sent successfully", //"An email has been sent to the email address regarding the further process",
  EMAIL_SENDOUT_ERROR: "Email address does not exists",
  STATUS_CHANGE_CONFIRM:
    "Are you sure you want to change the status of this abstractor?",
  STATUS_CHANGE_SUCCESS: "Status updated successfully",
  STATUS_CHANGE_FAIL: "Failed to update status",
};
export const Center_Msgs = {
  NAME_EMPTY: "Please enter the center name",
  NAME_EXISTS: "The center name already exists",
  ADD_SUCCESS: "Center added successfully",
  EDIT_SUCCESS: "Center updated successfully",
  DELETE_SUCCESS: "Center deleted successfully",
  DELETE_FAIL: "Error occurred when deleting center",
  CENTER_NOT_LOCKED:
    "Please fill out the Center Information form and then add patients.",
  CENTER_UNLOCK_CONFIRM: "Would you like to unlock the center?",
  UnlockSuccessMsg: "Center Unlocked successfully",
  CENTER_LOCKED: " Center information is Submitted and Locked",
  QUOTA_ALL_ZERO:
    "The patient cannot be added as the Target number of new charts is either not specified or is set to zero.",
  QUOTA_MET:
    "The patient cannot be added because the Target number of new charts for this cohort has already been reached.",
};
export const CenterInfo_Msgs = {
  C1: "Please choose one of the provided options",
  C1Txt: "Please specify the practice type",
  C2: "Please choose at least one of the provided options",
  C3: "Please select the US state or District of Columbia (DC)",
  C4: "Please choose one of the provided options",
  C5: "Please choose one of the provided options",
  C6: "Please enter a value between 0 and 20,000 (no decimals permitted) or otherwise specify “Unknown”",
  // C6_not_in_range: "Enter a value between 1 and 20,000.",
  C7: "Please enter a value between 0 and 20,000 (no decimals permitted) or otherwise specify “Unknown”",
  // C7_not_in_range: "Enter a value between 1 and 20,000.",
  C8: "Please enter a value between 0 and 200,000 (no decimals permitted) or otherwise specify “Unknown”",
  // C8_not_in_range: "Enter a value between 1 and 200,000.",
  C9: "Please enter a value between 0 and 40,000 (no decimals permitted) or otherwise specify “Unknown”",
  // C9_not_in_range: "Enter a value between 1 and 40,000.",
  Confirm: "Please confirm.",
  C10Txt:
    "Please describe the timing of use, the treatment, and dosing for this treatment",
};
export const Round_Msgs = {
  //NAME: "Enter center name",
  TARGET_CHARTS_EMPTY:
    "Please enter the target number of charts for all treatment cohorts.",
  ADD_SUCCESS: "Round added successfully",
  EDIT_SUCCESS: "Round updated successfully",
  ADD_FAIL: "Error occurred when adding round",
  //DELETE_SUCCESS: "Round deleted successfully",
  //DELETE_FAIL: "Error occurred when deleting round",
  TARGET_CHARTS_MINIMUM:
    "The count is below the required quota of {min} for {tx}. Please revise",
  NEXT_ROUND_NOT_ALLOWED:
    "A total of {count} patients are yet to complete the form. Once the form has been submitted by every patient from the current round, you can proceed to the next one.",
};
export const ResetPasswordMessages = {
  PASSWORD_BLANK: "Enter Password",
  CONFIRM_PASSWORD_BLANK: "Re-Enter Password",
  PASSWORD_MISMATCH: "Passwords did not match!",
  PASSWORD_INVALID:
    "Your password should include at least one lowercase letter, one uppercase letter, one number, and one symbol, with a minimum length of eight characters.",
  LINK_EXPIRED: "Link has expired",
  EMAIL_NOTEXISTS: "Email address does not exists",
  //100:"Some error!!! "
};
export const CommonError_Msgs = {
  LOAD_ERR: "Error occurred while loading.",
  SAVE_ERR: "Error occurred while saving.",
  REQUIRED: "This field is required.",
  Hard_Empty:
    "Please ensure that all mandatory fields are filled out before proceeding.",
  Hard_ValidationFail:
    "Please check the fields with errors and ensure all dates meet the required conditions to proceed.",
  DateChangeAlert:
    "The dates modified could impact the validation in the subsequent pages. Please validate the pages highlighted in red.",
  InvalidDate:
    "Invalid Date. Please enter a valid date and ensure that the date is not in the future.",
};
export const ForgotPassword = {
  EmailNotExistent:
    "This Email Address has not been set up - Please contact your Administrator to set this up.",
  EmailSuccess: "An Email has been sent to you regarding the further process.",
  ErrorOccurred: "Error occurred.",
};
export const CommonMsgs = {
  DeleteConfirmMsg: "Are you sure you want to delete this data?",
  SessionTimeout: "Your session has expired, you will be logged out now.",
  SubmitSuccess: "Patient Submitted Successfully",
  ConfirmMessage:
    "Once the checkbox is checked, it cannot be unchecked later. Are you sure you want to continue?",
};

export const PatientDashboard_Msgs = {
  ExportSuccess: "Data exported successfully",
  UnlockConfirmMsg:
    "Would you like to unlock and allow the abstractors to edit this patient?",
  UnlockSuccessMsg: "Patient Unlocked successfully",
  AbstractorNotesHeader: "Important notes to abstractors:",
  AbstractorNotesPtA:
    "a) If the patient died on or before the time of the previous round of data abstraction or has not had any new follow-up visits since the time of the previous round of data abstraction, the patient is not qualified for a chart update. ",
  AbstractorNotesPtB:
    " b) Patients are required to not receive any part of the cohort-defining line of therapy as part of a clinical trial. For some patients, the cohort-defining line of therapy could still be ongoing at the time of the previous round of data abstraction. If the patient received any subsequent parts of the cohort-defining line of therapy s part of a clinical trial from the time of the last round of data abstraction to the time of the current round of data abstraction, please do not update this patient's chart. Instead, this patient's record will be censored at the time of the last round of data abstraction.",
  UnlockEligibilityConfirmMsg:
    "Would you like to unlock and allow the abstractors to edit the Eligibility Criteria section of this patient?",
  DownloadSuccess: "Downloaded successfully",
  ExportAllAlertMsg:
    "To export all patient data, please ensure at least one patient is added.",
};
export const demographicScreen_Msgs = {
  Q1: "Please choose one of the provided options",
  Q2: "Please choose at least one of the provided options or “Unknown”",
  Q3: "Please choose one of the provided options",
  Q4: "Please select the US state or District of Columbia (DC)",
  Q5: "Please choose at least one of the provided options, “No insurance”, or “Unknown”",
  Q6: "Please choose one of the provided options",
  Q7: "Please choose one of the provided options",
  Q8: "Please choose one of the provided options",
  Q9: "Please choose one of the provided options",
  Q9a: "Please enter a value between 0 and 300 (up to 1 decimal permitted) or otherwise specify “Unknown”",
  Q10a: "Please enter the date of assessment (if known) or “Unknown” otherwise",
  Q10bw:
    "Please enter a value between the range specified or otherwise specify “Unknown”",
  Q10bKgw:
    "Please enter a value between 1 and 630 (up to 2 decimal permitted) or otherwise specify “Unknown”",
  Q10bLbsw:
    "Please enter a value between 1 and 1400 (up to 2 decimal permitted) or otherwise specify “Unknown”",
  Q10bh:
    "Please enter a value between the range specified or otherwise specify “Unknown”",
  Q10bFtIh:
    "Please enter a value for Feet between 1 and 9, Inches between 0 to 11 (no decimal permitted) or otherwise specify “Unknown”",
  Q10bCmh:
    "Please enter a value between 1 and 300 (no decimal permitted) or otherwise specify “Unknown”",
  Q10d: "This assessment does not fall within 1 year on or before the index date. Please enter the assessment closest to the index date within this 1-year window",

  Q10bGdlHemoglobin:
    "Please enter a valid hemoglobin measurement in g/dL (must be greater than 0 and less than 90)",
  Q10bGlHemoglobin:
    "Please enter a valid hemoglobin measurement in mg/L (must be greater than 0 and less than 900)",
  Q10bMmolHemoglobin:
    "Please enter a valid hemoglobin measurement in mmol/L (must be greater than 0 and less than 60)",
  Q10bHemoglobin: "Please select a hemoglobin measurement option",
  Q10bMlMinCreatinine:
    "Please enter a valid creatinine clearance measurement in mL/min (must be 0 or greater and less than 500)",
  Q10bMlSCreatinine:
    "Please enter a valid creatinine clearance measurement in mL/s (must be 0 or greater and less than 8.5)",
  Q10bLMinCreatinine:
    "Please enter a valid creatinine clearance measurement in L/min (must be 0 or greater and less than 0.60)",
  Q10bCreatinine: "Please select a creatinine clearance measurement option",
  Q10bUlLdh:
    "Please enter a valid LDH value in U/L (must be greater than 1 and less than 1,500)",
  Q10bIulLdh:
    "Please enter a valid LDH value in IU/L (must be greater than 1 and less than 1,500)",
  Q10bLdh: "Please select a valid LDH measurement option",
  Q10InvalidDt:
    "This assessment does not fall within 91 days on or before the index date. Please enter the assessment closest to the index date within this 91 days window",
};

export const NDMM_Criteria_Msgs = {
  title:
    "Patients will still be considered as having received a line of treatment if they received all therapy drugs except for dexamethasone or when dexamethasone has been replaced by prednisone or prednisolone.",
};

export const EligibilityCriteria_Msgs = {
  EligiblePatient:
    "This patient chart meets the study eligibility criteria. Please proceed to the next section of the chart abstraction form.",
  IneligiblePatient:
    "Thank you for entering the information, however the selected patient chart is not eligible for this study. No further information for this patient will be collected. Click on next arrow to proceed with entering a new patient chart.",
  INELIGIBLE:
    "This patient does not meet the eligibility criteria for this treatment cohort.",
  CohortIneligible:
    "This patient does not meet the eligibility criteria for this treatment cohort.",
  CrossWalkPtA:
    "Now you should have selected a patient for eligibility screening. This patient’s ID for the eMMpower study is [PatientId]. ",
  CrossWalkPtB:
    "Please save in your site's secured system a crosswalk between this patient's ID for eMMpower ([PatientId]) and the patient's ID in your site's secured system. ",
  CrossWalkPtC:
    "This crosswalk is critical and will be used in subsequent rounds of data abstraction to update this patient's charts. By answering 'Yes', you confirm that the crosswalk has been saved in your site's secured system, linking this patient's ID for eMMpower with the patient's ID at your site.",
  INVALID:
    "Patient must be at least 18 years of age at the date of Epcoritamab initiation.",
  DateCriteria1:
    "The date of treatment initiation with epcoritamab is before the date of LBCL diagnosis. Please revise your response.",
  DateCriteria2:
    "The date of treatment initiation with epcoritamab is on or before 05/19/2023. Please revise your response.",

  EndOfFollowUpValidationMsg:
    "Date of treatment initiation should be less or equal to end of follow up date",

  QS1: " Please specify if patient receive treatment with epcoritamab.",
  QS2: "Please select the date of initiation of treatment with epcoritamab.",
  QS3: "Please select the diagnosis of large B-cell lymphoma (LBCL).",
  QS4: "Please select the subtype of LBCL with which the patient is diagnosed.",
  QS5: "Please select the date when the patient was first diagnosed with LBCL.",
  QS6: "Please select the year of birth.",
  Radio: "Please choose one of the provided options",
  S3Date:
    "Please enter the date of initial MM diagnosis (if known) or “Unknown” otherwise ",
  S4Date: "Please enter the date of birth (if known) or “Unknown” otherwise",
  S4DOBValidate:
    "Please enter date of birth less than or equal to date of initial MM diagnosis",
  InvalidDate: "Invalid Date",
  S5: "Please choose one of the provided options",
  S6: "Please choose one of the provided options",
  S6Date:
    "Please enter the date of 1L treatment initiation (if known) or “Unknown” otherwise ",
  S7: "Please choose one of the provided options",
  S51: "Please choose one of the provided options",
  S8: "Please choose one of the provided options",
  S9: "Please choose one of the provided options",
  S10: "Please choose at least one of the provided options",
  S11: "Please choose at least one of the provided options or “None of the above treatments",
  S11Date:
    "Please enter the date of treatment initiation (if known) or “Unknown” otherwise ",
  s13: "Please choose one of the provided options",
  s14: "Please choose one of the provided options",
  s15: "Please choose one of the provided options",
  s16: "Please choose at least one of the provided options",
  EligibiltyLockConfirm:
    "You are about to lock the eligibility responses. Once locked, they cannot be changed.",
  EligibiltyLockConfirm1:
    "Select 'OK' to confirm and proceed, or 'Cancel' to go back.",
  CohortIneligibleWarning:
    "WARNING: you have defined the date of treatment initiation before either the FDA approval date or January 01, 2020. If left unchanged, this patient will be considered ineligible upon validating this form. Please confirm this date of initiation and update, as needed.",
  NDMMIndexDateWarning:
    "WARNING: you have defined the date of treatment initiation before the patient’s date of birth and/or MM diagnosis. Please confirm the dates of birth, MM diagnosis, and 1L NDMM treatment initiation and update, as needed.",
  RRMMInitiationDateWarning: (
    <>
      WARNING: you have either unknown date of treatment initiation, defined the
      date of treatment initiation before the FDA approval date, or defined the
      RRMM initiation date before the patient’s date of birth, initial MM
      diagnosis, or any reported NDMM initiation date. If left unchanged, this
      patient will be considered <i>ineligible</i> upon validating this form.
      Please confirm the date of initiation and update, as needed.
    </>
  ),
  PatientUnder18Warning: (
    <>
      WARNING: based on dates of treatment initiation and dates of birth, the
      patient was not 18+ years of age at the time of treatment initiation. If
      left unchanged, this patient will be considered <i>ineligible</i> upon
      validating this form. Please confirm the dates of birth and treatment
      initiation are correct and update, as needed. Alternatively, if the
      patient received the treatment as part of combination therapy, correctly
      indicate this.
    </>
  ),
  RRMMTIEWarningMessage:
    "WARNING: you have defined the IsaVRd TIE patient’s date of treatment initiation before the FDA approval date of September 20, 2024. If left unchanged, this patient will be considered ineligible upon validating this form. Please confirm this date of initiation in S6 and update, as needed.",

  eligibilityWarning:
    "WARNING: you have either: (i) an unknown date of treatment initiation for a combination agent, (ii) the earliest agent initiation date precedes the patient’s date of birth, initial MM diagnosis, or any reported NDMM initiation date, or (iii) a combination agent initiation date for a Bispecific/CAR-T therapy exceeds the start of another Bispecific/CAR-T therapy. If left unchanged, this patient will be considered ineligible upon validating this form. Please confirm the dates of initiation for each agent and update, as needed.",
  S11LOTRange:
    "Please enter a valid line of therapy number between 2 and 40 (no decimals).",
  RRMMRowChronologyError:
    "ERROR – the line of therapy numbers cause the start of a later line of therapy to precede the subsequent line of therapy. Please review dates and revise accordingly.",
  RRMMDuplicateRowError:
    "ERROR – the same treatment and line of therapy combination has been entered more than once. Please review and revise.",
  TecTalMutualExclusionError:
    "ERROR – Teclistamab and Talquetamab cannot be entered for the same line of therapy. Please review and revise.",
};

export const DiseaseHistErrorMsg = {
  ProvideOptions: "Please choose one of the provided options",
  DateFirstErrMsg:
    "Please enter the date of first radiotherapy (if known) or “Unknown” otherwise ",
  DateLastErrMsg:
    "Please enter the date of last radiotherapy (if known) or “Unknown” otherwise ",
  DateFirstValidMsg:
    "The date of first radiotherapy entered is invalid; please enter a date that is on or within 91 days prior to the index date ([IndexDate]) and not later than the index date for [Cohort].",
  DateLastValidMsg:
    "The date of last radiotherapy entered is invalid; please enter a date that is on or within 91 days prior to the index date ([IndexDate]) and not later than the index date for [Cohort].",

  RangeErrMsg:
    "Please enter a value between 0 and 100 (up to 1 decimal permitted) or otherwise specify “Unknown”",
};

export const ComborbidityErrorMsg = {
  q18EmptyHard:
    "Please choose at least one of the provided options or None of the above",
  pulmonaryEmptyHard:
    "Please choose one of the options listed under chronic pulmonary diseases",
  KidneyEmptyHard:
    "Please choose one of the options listed under chronic kidney disease ",
  neuropathyEmptyHard:
    "Please choose one of the options listed under neuropathy",
  malignancyEmptyHard:
    "Please choose one of the options listed under malignancy",
  cardiovascularEmptyHard:
    "Please choose one of the options listed under cardiovascular disease",
};

export const TTCharacteristics_MSGS = {
  //TECHVAYLI
  // administrationEmpty: "Choose one of the options for Date of dose of administration",
  // dosingphaseEmpty: "Choose dosing phase",
  // siteofcareEmpty: "Choose site of care",
  // admissionEmpty: "Choose Date of  impatient admission",
  // dischargeEmpty: "Choose Date of  impatient discharge",
  DecimalRange:
    "Please enter a value between 0.00 and 4000 (up to 2 decimals permitted)",
  General: "Please choose one of the provided options",
  name_dose_steroidstalHardEmpty:
    "Please choose at least one of the provided options or Unknown ",
  steroids_tal_txtEmpty: "Please describe the total dose strength",
  steroids_tech_txtEmpty: "Please describe the total dose strength",
  name_dose_steroidsHardEmpty:
    "Please choose at least one of the provided options or Unknown ",
  administrationEmpty: "Please choose one of the provided options",
  dosingphaseEmpty: "Please choose one of the provided options",
  siteofcareEmpty: "Please choose one of the provided options",
  admissionEmpty: "Please choose one of the provided options",
  doseFrequencyEmpty: "Please choose one of the provided options",
  doseFrequencyValueEmpty: "Please enter week value for dose frequency",
  dischargeEmpty: "Please choose one of the provided options",
  administrationEmptyDate:
    "Please enter the date of dose administration (if known) or unknown ",
  admissionEmptyDate:
    "Please enter the date of admission (if known) or unknown ",
  dischargeEmptyDate:
    "Please enter the date of discharge (if known) or “Unknown” ",
  admissionDateCheck:
    "Please select date of admission which is not less than date of discharge",
  dischargeDateCheck:
    "Please Select date of discharge which is greater than date of admission",
  indexDateRRMMNotMatchingTech:
    "Please Select at least 1 date of dose administration(Tecvayli) = Bispecific/CAR-T initiation date ",

  indexDateRRMMNotMatchingTal:
    "Please Select at least 1 date of dose administration(Talvey) = Bispecific/CAR-T initiation date ",

  RRMMNotMatchingTech:
    "The number of dose administrations (rows) listed in Q36(Tecvayli) does not match what is expected based on your response in Q26 “Number of administrations.” Please check and ensure that these match.",

  RRMMNotMatchingTal:
    "The number of dose administrations (rows) listed in Q36(Talvey) does not match what is expected based on your response in Q26 “Number of administrations.” Please check and ensure that these match.",

  DoseMustMatchLastAdministrationDateTec:
    "Please select at least 1 date of dose administration (Tecvayli) = date of last administration in Q26 (Tecvayli)",
  DoseMustMatchLastAdministrationDateTal:
    "Please select at least 1 date of dose administration (Talvey) = date of last administration in Q26 (Talvey)",

  Q39TechSteroidsEmptyHard:
    "Please choose at least one of the provided options or Unknown",
  Q39TechEmptyHard: "Please choose one of the provided options",
  Q39TechReasonHard:
    "Please choose at least one of the provided options or Unknown",
  Q39GranulocyteEmptyHard:
    "Please choose at least one of the provided options or Unknown",

  Q39TalEmptyHard: "Please choose one of the provided options",
  Q39TalReasonHard:
    "Please choose at least one of the provided options or Unknown",
  Q39TalSteroidsEmptyHard:
    "Please choose at least one of the provided options or Unknown",

  // Q39.C - Tecvayli / Talvey messages (eCRF New Elements C)
  Q39CEmptyHard: "Please choose one of the provided options",
  Q391CReasonEmptyHard:
    "Please choose at least one of the provided options or Unknown",
  Q391CDateEmpty: "Please enter the administration date or choose Unknown",
  Q391CDateInvalid: "Please enter a valid date",
  Q391CDoseEmptyHard: "Please provide dose information or choose Unknown",
  Q391CDoseOtherEmptyHard: "Please specify the dose",
  Q391CDoseRangeInvalid:
    "Please enter a value greater than 0 and less than or equal to 15",

  // Q39.2.C - Tecvayli / Talvey messages (eCRF New Elements C)
  Q392CDoseEmptyHard:
    "Please select at least one steroid and provide its dose per day, or choose Unknown",
  Q392CDoseTxtEmptyHard:
    "Please provide the dose per day for the selected steroid(s)",
  Q392CDoseRangeInvalid: "Please enter a value greater than or equal to 0",
  Q392CReasonEmptyHard:
    "Please choose at least one of the provided options or Unknown",

  // Q39.3.C - Tecvayli / Talvey messages (eCRF New Elements C)
  Q393CReasonEmptyHard:
    "Please choose at least one of the provided options or Unknown",

  Q38TechEmptyHard: "Please choose one of the provided options",
  Q38DateEmpty:
    "Please enter the date of dose frequency reduction (if known) or unknown otherwise",
  Q38TechDateInvalid:
    "At least one of the dates of dose frequency reduction is invalid. Please ensure that all dates of dose frequency reduction are after the treatment initiation date and on or before the date of last dose administration, start date of subsequent LOT, end of follow-up for the treatment cohort.",

  Q38TalEmptyHard: "Please choose one of the provided options",
  Q38TalDateEmpty:
    "Please enter the date of dose frequency reduction (if known) or unknown otherwise",
  Q38TalDateInvalid:
    "At least one of the dates of dose frequency reduction is invalid. Please ensure that all dates of dose frequency reduction are after the treatment initiation date and on or before the date of last dose administration, start date of subsequent LOT, end of follow-up for the treatment cohort.",

  specifyOtherText: "Please specify other text",
  specifyOtherFreqText: "Please specify a valid other frequency",
  specifyDosageFrequency: "Please describe the dosing strength",
  allowedRange: "Please enter a value between 0 and 50",
  //TALVEY
  administrationEmpty_tal: "Please choose one of the provided options",
  dosingphaseEmpty_tal: "Please choose one of the provided options",
  siteofcareEmpty_tal: "Please choose one of the provided options",
  admissionEmpty_tal: "Please choose one of the provided options",
  dischargeEmpty_tal: "Please choose one of the provided options",

  //37
  q37TalveyEmpty: "Please choose one of the provided options",
  q37TechvayliEmpty: "Please choose one of the provided options",

  //40
  Q40DosingFreqEmptyHard: "Please choose one of the provided options",
  Q40DosingFreqTxtEmptyHard: "Please enter the dosing frequency",
  Q40IgGEmptyHard: "Please choose one of the provided options",
  Q40Init_dtHard:
    "Please enter the initiation date of IVIG (if known) or unknown otherwise",
  Q40Init_RdHard: "Please choose one of the provided options",
  Q40ReasonEmptyHard: "Please choose at least one of the provided options",

  //40.C
  ivigInitRdHardC: "Please choose one of the provided options",
  ivigInitDtHardC: "Please enter the initiation date of IVIG",
  ivigInitDtInvalidC: "Please enter a valid date",
  ivigInitDtBeforeEofC:
    "Date should be between Bispecific/CAR-T initiation date and end of follow up",
  ivigInitDtFullChainOutOfRangeC:
    "Please ensure that the Bispecific/CAR-T Index Date is on or before the Bispecific/CAR-T Initiation Date, which is on or before the Date in Column [B], the Date of Last Administration reported in Column [D] of Q26 (if known), the End Date of LOT in Q26.2, the Start Date of Subsequent LOT (if reported), and the End of Follow-up.",
  ivigDosingTypeEmptyHardC: "Please choose one of the provided options",
  ivigDosingFreqEmptyHardC: "Please choose one of the provided options",
  ivigDosingFreqTxtEmptyHardC: "Please enter the dosing frequency",
  ivigDosingFreqRangeInvalidC: "Allowed range: > 0 and ≤ 10; integers only",
  ivigReasonEmptyHardC: "Please choose at least one of the provided options",
  ivigReasonOtherTxtEmptyHardC: "Please specify the other reason",
  ivigDoseStrengthEmptyHardC: "Please provide the initial dose strength",
  ivigDoseStrengthRangeInvalidC: "Allowed range: > 0 and < 200",
  ivigDoseStrengthMgKgRangeInvalidC: "Allowed range: > 0 and < 2000",
  ivigDoseStrengthOtherTxtEmptyHardC: "Please specify the dose strength",
  ivigBodyWeightEmptyHardC: "Please choose one of the provided options",
  ivigBodyWeightKgRangeInvalidC:
    "Allowed range: ≥ 1 and ≤ 630; up to two decimal places",
  ivigBodyWeightLbsRangeInvalidC:
    "Allowed range: ≥ 1 and ≤ 1400; up to two decimal places",
  ivigLastIggEmptyHardC: "Please choose one of the provided options",

  // Q36DateGreaterThanPrevious: "Date of dose administration should be greater than the previous dose",
  //Q36.1
  Q36Point1ReasonTxtEmpty: "Please enter the hospitalization reason",
  //36
  Q36DateOutOfBound:
    "The date must be on or after the Bispecific/CAR-T index date and Bispecific/CAR-T initiation date, and on or before the last administration date in Q26 (if known), the end date of LOT in Q26.2, the start date of the subsequent LOT (if applicable), and the end of follow-up date.",

  DateBeforeEOF: "The date must be on or before the End of Follow-up date.",

  //Q36
  DuplicateDateNotAllowed:
    "{value} cannot have duplicate date of dose administration.",
  DuplicateStepUpNotAllowed:
    "WARNING: you have entered duplicate dose administrations with the same step-up dosing phase (i.e., at least two rows where Step-up dose 1, Step-up dose 2, Step-up dose 3, or 1st treatment dose have been recorded). The likelihood of this occurrence is considered rare and should occur only if multiple step-up doses occurred. If the patient did not experience multiple step-up doses, please revise accordingly.",
  NoStepUpWarning:
    "WARNING: you have entered 1st treatment dose but no other step-up dosing information. It is expected that patients should receive Step-up dose 1, Step-up dose 2, and (when applicable) Step-up dose 3. Please double-check and add any missing records for step-up dosing.",
  Q26Warning:
    "WARNING: Based on the number of administrations provided in Q26, it is expected that the patient received all step-up doses and the 1st subsequent treatment dose. Please double-check and add any missing records.",
  Dose2Warning:
    "Step-up Dose 2 cannot be reported as Patient did not receive dose when Step-up Dose 3 has been reported with a date or as Date unknown.",
  FirstTreatmentWarning:
    "Step-up Dose 2 or Step-up Dose 3 cannot be reported as Patient did not receive dose when the 1st Treatment Dose has been reported with a date or as Date unknown.",
  FirstSubsWarning:
    "Step-up Dose 2, Step-up Dose 3, or 1st Treatment Dose cannot be reported as Patient did not receive dose when the 1st Subsequent Treatment Dose has been reported with a date or as Date unknown.",

  //Q36.1
  Q361DateRangeError:
    "The date must be on or after the Bispecific/CAR-T initiation date - 2 days and on or before the 1st subsequent treatment dose in Q36, the last administration date in Q26 (if known), the end date of LOT in Q26.2, the start date of the subsequent LOT (if applicable), and the end of follow-up date.",
  AtleastOneStepUpWarning:
    "WARNING: this patient was indicated to have at least one step-up dosing administration (e.g., Step-up dose 1, Step-up dose 2, Step-up dose 3, 1st treatment dose) in an inpatient setting, yet no hospitalizations have been reported here. Please revise to provide the dates of hospitalizations related to Bispecific treatment administration or otherwise revise the setting of care of the step-up dosing phase administrations.",
  DateRangeThirty:
    "WARNING: you have entered at least one hospitalization with a duration that exceeds 1 month in duration. Please confirm the start and end dates of all hospitalizations and revise accordingly, as needed.",
  DischargeMoreThanAdministrationWarning:
    "WARNING: you have indicated that at least one hospitalization has a date of discharge that end after the latest date of Bispecific dose administration in Q36. Please confirm that all dates of hospitalization discharge and dates of last dose administrations are entered correctly and revise accordingly, if needed.",

  //Q37
  AtleasetOneAdministrationWarning:
    "WARNING: this patient was indicated to have at least one administration after concluding the step-up dosing phase (e.g., a subsequent treatment dose administration) in Q36, yet the patient was indicated as not having completed the step-up dosing phase here. Please revise the response to the initial dosing frequency after index or otherwise revise the dosing phase of administrations in Q36, as needed.",

  //Q38
  Q38TTFrequencyConflict:
    "WARNING: the initial dose frequency after step-up dosing is less than the dose frequency reported after the dose frequency reduction. Please revise such that the dose frequency after reduction is less than that immediately after step-up dosing or modify your response on the presence of a dose frequency reduction in Q37.",
  Q381ABeforeChangeQ36MismatchHard:
    "This value does not match any of the dosing patterns reported in Q36 for the 1st subsequent treatment dose. Please revise so it matches a pattern reported in Q36.",
  Q391AAdministrationDateOutOfRange:
    "Tocilizumab Administration Date must be between the Bispecifics/CAR-T initiation date and the start date of the subsequent line of therapy, and on or before the end of follow-up",
  Q391ATocilizumabDateChainOutOfBound:
    "Date must be on or after the Bispecific/CAR-T index date, initiation date and the earliest 1st subsequent treatment dose in Q36, and on or before last administration date of Q26, LOT end date of Q26.2, subsequent LOT start date, and end of follow-up.",

  //Q36 New Date Validations
  Q362L3LErrorMessage:
    "One or more dates are out of sequence. The latest dose administration date must be on or before the discontinuation date of the current LOT, which must be on or before the start date of the next LOT, and all must be on or before the end of follow-up.",
  Q381AWarningUnk:
    "WARNING: dose frequency or dose strength has been listed as unknown for at least one reported change. Please attempt to infer the dose frequency or strength both before and after the change based on information within the patient chart. Only use the unknown option if there is truly no information reported on the dose frequency/strength (note that directionality of change is required).",
  Q381AChainMismatchWarning:
    "WARNING: for at least one dose frequency or dose strength change, the pattern after change does not match the pattern before the next chronological change of the same type. Please confirm the values and dates entered are correct and revise accordingly, as needed.",
  //AUTO-009 - Q36 reports more than one 1st subsequent treatment dose and the
  //first change's "Pattern before change" matches none of them.
  Q381AQ36PatternBeforeMismatch:
    "The first dose frequency or dose strength change reports a “Pattern before change” that differs from the 1st subsequent treatment dose provided in Q36. It is expected that the initial dose frequency and dose strength in these questions match before any changes. Please reconcile with Q36 or add any missing dose changes.",
  Q382AWarningUnk:
    "WARNING: at least one date has been listed as unknown for at least one dose interruption episode. Please attempt to infer the dose interruption start and end dates based on information within the patient chart.",
  Q38ReasonEmpty:
    "Please select at least one reason (if known) or unknown otherwise",
  Q38AEEmpty:
    "Please select at least one AE type (if known) or AE type unknown otherwise",
  Q38AENeurologicEmpty: "Please select at least one neurologic event",
  Q38AENeurologicOther: "Please specify other neurologic event",
  Q38ReasonOtherEmpty: "Please specify other reason",
  FrequencyIncreaseConflict:
    "Frequency after change must be greater than before",
  FrequencyDecreaseConflict: "Frequency after change must be less than before",
  DateChangeOutOfBound:
    "Date must be on or after the Bispecific/CAR-T index date, initiation date and the earliest 1st subsequent treatment dose in Q36, and on or before last administration date of Q26, LOT end date of Q26.2, subsequent LOT start date, and end of follow-up.",
  WarningForIVIGQ401a:
    "WARNING: you have indicated specific reasons for receiving IGRT in Q40 yet these same reasons are not listed at least once across all administrations of IGRT in Q41.1.B. Please confirm all reasons for IGRT administrations in both questions.",

  //Q40.1.B
  Q401aSelect_RdHard: "Please choose one of the provided options",
  Q401aDateAdm_Hard:
    "Please enter the Date of IGRT administration date (if known) or unknown otherwise",
  Q401aFrequencyEmptyHard: "Please enter dosing frequency range",
  Q401aSelectCheckbox_RdHard:
    "Please choose at least one of the provided options",
  Q401aDosageEmptyHardG: "Please enter dosage value g between 1 to 200",
  Q401aDosageEmptyHardMG: "Please enter dosage value mg/kg between 1 to 2000",
  Q401aBodyWeightEmptyHardKg:
    "Please enter body weight value kg between 1 to 630 (up to 2 decimals permitted) or otherwise specify “Unknown” ",
  Q401aBodyWeightEmptyHardLbs:
    "Please enter body weight value lbs between 1 to 1400 (up to 2 decimals permitted) or otherwise specify “Unknown” ",
  Q401aDateWeight_Hard:
    "Please enter the Date of weight assessment date (if known) or unknown otherwise",

  //40.1.C
  Q401cChangeTypeEmptyHard: "Please choose one of the provided options",
  Q401cFreqBeforeEmptyHard: "Please provide dose frequency before change",
  Q401cFreqBeforeTxtEmptyHard: "Please enter the dosing frequency",
  Q401cFreqBeforeRangeInvalid: "Allowed range: > 0 and ≤ 10; integers only",
  Q401cFreqAfterEmptyHard: "Please provide dose frequency after change",
  Q401cFreqAfterTxtEmptyHard: "Please enter the dosing frequency",
  Q401cFreqAfterRangeInvalid: "Allowed range: > 0 and ≤ 10; integers only",
  Q401cDateChangeRdHard: "Please choose one of the provided options",
  Q401cDateChangeDtHard:
    "Please enter the date of dose frequency change (if known) or unknown otherwise",
  Q401cDateChangeInvalid: "Please enter a valid date",
  Q401cDateChangeOutOfBound:
    "The date must be on or after the IVIG initiation date (or Bispecific/CAR-T initiation date, if unknown) and on or before the start date of the next LOT (if applicable) or end of follow-up",
  Q401cFrequencyIncreaseConflict:
    "Dose frequency after change must be greater than before",
  Q401cFrequencyDecreaseConflict:
    "Dose frequency after change must be less than before",
  Q401cChainMismatchWarning:
    "WARNING: for at least one dose frequency change, the dose frequency after change does not match the dose frequency before the next chronological change. Please confirm the dose frequency values and dates entered are correct and revise accordingly, as needed.",

  DateBeforeEOFAfterIndex:
    "The date must be on or after the Index Date and on or before the start date of next LOT (if applicable) or end of follow-up for the last LOT.",

  Q402BDateBeforeEOFAfterIndex91:
    "The date must be on or after the Index Date - 91 days and on or before Index Date + 7 days, the start date of next LOT (if applicable), and the end of follow-up date for the last LOT.",

  Q403BDateRangeError:
    "The date must be on or after the Index Date - 91 days and Q40 date - 91 days and on or before the start date of next LOT (if applicable), and the end of follow-up date for the last LOT.",

  //Q40.2.B
  Q402aSelect_RdHard: "Please choose one of the provided options",
  Q402aIggDateAdm_Hard:
    "Please enter the Date of IgG administration date (if known) or unknown otherwise",
  Q402aLevelRangeHardGL: "Please enter dosage value g/L between 1 to 50",
  Q402aLevelRangeHardMG: "Please enter dosage value mg/dL between 1 to 5000",

  Q40DateOutOfRange:
    "The date must be on or after the Index Date and on or before the start date of next LOT (if applicable) or end of follow-up for the last LOT.",
  Q40FullChainOutOfRange:
    "Please ensure that the Bispecific/CAR-T Index Date is on or before the Bispecific/CAR-T Initiation Date, which is on or before the Date in Column [B], the Date of Last Administration reported in Column [D] of Q26 (if known), the End Date of LOT in Q26.2, the Start Date of Subsequent LOT (if reported), and the End of Follow-up.",

  //Q40.2.C
  Q402cSelect_RdHard: "Please choose one of the provided options",
  Q402cIggDateAdm_Hard:
    "Please enter the date of IgG assessment (if known) or unknown otherwise",
  Q402cLevelBucketEmptyHard: "Please choose one of the provided options",
  Q402cLevelRangeHardMG: "Please enter dosage value mg/dL between 1 to 5000",
  Q402cLevelRangeHardGL: "Please enter dosage value g/L between 1 to 50",
  Q402cDateOutOfRange:
    "The date must fall within the target assessment window shown above and on or before the start date of the next LOT (if applicable) or end of follow-up.",
  Q402cRow1NotEarliest:
    "The IgG assessment closest to the start of bispecific treatment must be on or before all other reported IgG assessment dates in this table. Please revise accordingly.",
  Q402cRow2ThresholdConflict:
    "WARNING: at least one row reports an IgG level of 400-500 mg/dL or >500 mg/dL, but the highest IgG level reported is not consistent with this. Please revise accordingly.",
  Q402cDatesNotChronological:
    "WARNING: the dates of IgG assessment are not in chronological order across rows. Please confirm the dates entered are correct and revise accordingly.",
};

export const NDMMTreatmentCohort_Msgs = {
  q21: "Please choose one of the provided options",
  q23: "Please fill data for Consolidation therapy",
  q24: "Please fill data for Maintenance therapy",
  q22_25a: "Please choose one of the provided options",
  q22_25aOth: "Please enter the other agent",
  q22_25b:
    "Please enter the date of first administration (if known) or unknown otherwise",
  q22_25b_idx:
    "The date of first administration and/or last administration are invalid; please ensure that: (i) at least one date of first administration is the same as the date of 1L NDMM treatment initiation",
  q22_25b_sf:
    "Date of first administration must be on or before the end of follow up date",
  q22_25b_se:
    "Date of last administration must be on or before the first administration date",
  q22_25c:
    "Please enter the date of last administration (if known) or unknown otherwise",
  q22_25c_ef:
    "Date of last administration must be on or before the end of follow up date",
  q22_25c_sef:
    "The date of first administration and/or last administration are invalid; please ensure that: (i) for each agent, the date of first administration is on or before the date of last administration, and (ii) Please ensure that the date of last administration is on or before the end of follow-up date for the treatment cohort.",
  q22_25c_sef_p2:
    "The date of first administration and/or last administration are invalid; please ensure that: (i) for each agent, the date of first administration is on or before the date of last administration, and (ii) All dates of first and last administrations of induction agents are on or before the earliest first administration of all consolidation agents and are on or before the patient’s date of death (if applicable) and end of 1L NDMM line of therapy.",
  q22_25c_sef_p3:
    "The date of first administration and/or last administration are invalid; please ensure that: (i) for each agent, the date of first administration is on or before the date of last administration, and (ii) All dates of first and last administrations of induction and consolidation agents are on or before the earliest first administration of all maintenance agents and are on or before the patient’s date of death (if applicable) and end of 1L NDMM line of therapy.",
  q22_25d:
    "Please enter a value between 1 and 4000 or otherwise specify “Unknown”",
  q22_25dTxt: "Please enter dosing schedule",
  q22_25e: "Please choose one of the provided options",
  q22_25f: "Please choose at least one of the provided options or “Unknown”",
  q22_25fa: "Please enter the reason for discontinuing",
  q22_25f_death:
    "WARNING: you have indicated that at least 1 reason for medication discontinuation was death however no date of death is reported in Q20. Please revise the reason for medication discontinuation to a reason besides death or otherwise add a date of death in Q20.",
  q22_25e_unk:
    "WARNING: the discontinuation status for this medication has been listed as unknown. Please attempt to infer the discontinuation status using information provided within the patient chart. Only use the <i>unknown</i> option if there is truly no information reported on medication discontinuation status.",
  qDuplicateAgent:
    "This option is already provided in the dropdown menu. Please select the option there",
  q22_25g:
    "Please enter a value between 0.01 and {value} (up to 2 decimals permitted) or otherwise specify “Unknown”",
  bortezomibDateError:
    "Please enter the date of bortezomib dose frequency modification (if known) or unknown otherwise",
  radioOptionError: "Please choose one of the provided options",
  bortezomibDoseFrequencyBeforeError:
    "Please provide dose frequency before modification",
  bortezomibDoseFrequencyAfterError:
    "Please provide dose frequency after modification",
  bortezomibRangeError: "Please enter a value between 1 and 10",
  bortezomibBeforeOthTxtError:
    "Please provide before modification dosing schedule",
  bortezomibAfterOthTxtError:
    "Please provide after modification dosing schedule",
  lenalidomideRangeError:
    "Please enter a value between 0.01 and 50 (up to 2 decimals)",
  SameUnitError:
    "You have selected the same unit for dose frequency before and after modification. Please ensure the numeric values are not identical",
  q22ADateOutOfBondError:
    "Date must be between first bortezomib administration or NDMM index date and the earliest of RRMM index date, last administration, consolidation start, maintenance start, or end of follow-up",
  q24ADateOutOfBondError:
    "Date must be on or after the NDMM index date, the latest date of first or last administration of any 1L induction or 1L consolidation therapy agent, and first bortezomib administration, and no later than the earliest of RRMM index date, last administration, or end of follow-up",
  q23ADateOutOfBondError:
    "Date must be on or after the NDMM index date, the latest date of first or last administration of any 1L induction therapy agent, and first bortezomib administration, and no later than the earliest of RRMM index date, last administration, maintenance start, or end of follow-up",
  q25ADateOutOfBondError:
    "Date must be between first bortezomib administration or NDMM index date and the earliest of RRMM index date, last administration, or end of follow-up",
  lenalidomideDoseStrengthBeforeError:
    "Please provide dose strength before modification",
  lenalidomideDoseStrengthAfterError:
    "Please provide dose strength after modification",
  lenalidomideDateError:
    "Please enter the date of lenalidomide dose strength modification (if known) or unknown otherwise",

  q22LenoADateOutOfBondError:
    "Date must be between first lenalidomide administration or NDMM index date and the earliest of RRMM index date, last administration, consolidation start, maintenance start, or end of follow-up",
  q24LenoADateOutOfBondError:
    "Date must be on or after the NDMM index date, the latest date of first or last administration of any 1L induction or 1L consolidation therapy agent, and first lenalidomide administration, and no later than the earliest of RRMM index date, last administration, or end of follow-up",
  q23LenoADateOutOfBondError:
    "Date must be on or after the NDMM index date, the latest date of first or last administration of any 1L induction therapy agent, and first lenalidomide administration, and no later than the earliest of RRMM index date, last administration, maintenance start, or end of follow-up",
  bortezomibDoseFrequencyUnknownWarning:
    "WARNING: you have reported an unknown dose frequency before and/or after the modification. Please provide or infer (based on patient's records) the dose frequency for the last pair of consecutive administrations prior to the modification and/or the next known pair of consecutive administrations after the modification using information from the patient's chart, as available.",
  q22LenoUnknownDoseStrengthWarning:
    "WARNING: you have reported an unknown dose strength before and/or after the modification. Please provide or infer (based on patient's records) the dose strength for the last known administration prior to the modification and/or the next known administration after the modification using information from the patient's chart, as available.",
  lenoUnknownDoseStrengthWarning:
    "WARNING: you have reported an unknown dose strength before and/or after the dose modification. Please provide or infer (based on patient's records) the dose strength for the last known administration prior to the modification and/or the next known administration after the modification using information from the patient's chart, as available.",
  q22AgentStartDateAfterRRMMError:
    "The date of first administration must be on or before the earliest RRMM index date.",
  q22AgentEndDateAfterRRMMError:
    "The date of last administration must be on or before the earliest RRMM index date.",
  q25_chain:
    "Please ensure that the Date of Initial MM Diagnosis is on or before the NDMM Index Date, which is on or before the 1L Agent Start Date, 1L Agent End Date, and End of Follow-up.",
  q22_chain:
    "Please ensure that the Date of Initial MM Diagnosis is on or before the NDMM Index Date, which is on or before the 1L Induction Agent Start Date, 1L Induction Agent End Date, and End of Follow-up.",
  q23_chain:
    "Please ensure that the NDMM Index Date is on or before the latest 1L Induction Agent End Date, which is on or before the 1L Consolidation Agent Start Date.",
  q24_chain:
    "Please ensure that the NDMM Index Date is on or before the latest 1L Induction Agent End Date, which is on or before the latest 1L Consolidation Agent End Date, which is on or before the 1L Maintenance Agent Start Date.",
  q24_ongoingBlock:
    "WARNING: at least 1 induction and/or consolidation phase medication is ongoing, and therefore maintenance therapy cannot be entered. Please revise your selections in Q21 or otherwise indicate that the induction and consolidation phases have discontinued.",
  q23_ongoingBlock:
    "WARNING: at least 1 induction phase medication is ongoing, and therefore consolidation therapy cannot be entered. Please revise your selections in Q21 or otherwise indicate that the induction phase has discontinued.",
};

// Needs inline markup (italics on "Unknown"), so it can't be a plain string like the messages above.
export const GetOngoingLastAdminUnknownWarning = (lastEncounterDate) => (
  <>
    WARNING: you have noted that the medication is ongoing at the time of last
    encounter and listed the date of last administration as <i>Unknown</i>.
    Please provide the date of the last known administration of the medication
    prior to the patient’s last encounter on{" "}
    {lastEncounterDate || "[date of last encounter]"} or infer the date of last
    known administration using information provided within the patient’s chart,
    if possible. Only state that the date of last administration is unknown if
    there are no known administrations of the medication during this phase/line
    of therapy.
  </>
);

export const BispecificCartTreatmentCohort_Msgs = {
  q26b: "Please enter the line of therapy between 2 and 40",
  q26d: "Please enter the date of last administration (if known) or unknown otherwise",
  q26d_sef:
    "The date of last administration is invalid; please ensure that the date of last administration is on or after the date of first administration for the treatment cohort.",
  q26_secondDate:
    "Please enter the date of second administration (if known) or unknown otherwise",
  q26_secondDateRange:
    "Please ensure that the date of second daratumumab administration is after the Bispecifics/CAR-T agent initiation date and on or before the minimum of the Bispecifics/CAR-T agent end date, the next line of therapy start date, and the end of follow-up date.",
  q26e: "Please enter a value between 1 and 4000 or otherwise specify “Unknown”",
  q26eTxt: "Please enter dosing schedule",
  q26f: "Please choose one of the provided options",
  q26g: "Please choose at least one of the provided options or “Unknown”",
  q26ga: "Please enter the reason for discontinuing",
  q26d_lef:
    "Please ensure that the date of last administration is on or before  the end of follow-up date for the treatment cohort.",
  q26d_date:
    "ERROR - the line of therapy numbers cause the start of a later line of therapy to precede a subsequent line of therapy. Please review these dates. If correct, please contact eMMpower@analysisgroup.com.",
  q26_lotDateRangeError:
    "ERROR - Date of first admin and/or last admin fall outside of the expected range. Please ensure that all dates of first admin are on or after the LOT index date. Date of last administration should be (i) on or after date of first administration and (ii) on or before date of first admin on next LOT. ",
  q26d_ef:
    "Please ensure that the date of first administration is on or before the end of follow- up date  for the treatment cohort",
  q26duplicateb:
    "Repeated line of therapy values cannot be accepted between regimens. Please enter a different line of therapy.",
  q26h: "Please enter a value between 0.01 and 4000 (up to 2 decimals permitted)",
  q26ae: "Please select adverse events.",
  q26aeNeuro: "Please select neurological events.",
  q26aeNeuroOther: "Please enter text in other neurological events.",

  q262_B: "Please enter the LOT start date (if known) or “Unknown” otherwise",
  q262_C: "Please enter the LOT end date (if known) or “Unknown” otherwise",
  q262_D: "Please choose at least one of the provided options",
  q262_EF: "Please choose one of the provided options",
  q262_G: "Please choose at least one of the provided options",
  q262_D_txt: "Please enter the name for the other therapy received.",
  q262_BC_Warning:
    "WARNING: the start or end date of at least 1 LOT is reported as unknown. Please attempt to infer the start and/or end dates using information provided within the patient chart. Only use the unknown option if there is truly no information reported on LOT dates. If a LOT end date is unknown but a subsequent LOT occurred, define the LOT end date as the subsequent LOT start date -1 day.",
  q262_AfterPrevLot:
    "Date should be beyond or equal to “Previous LOT end date”",
  q262_AfterLotStart: "Date should be beyond or equal to “LOT start date”",
  q262_CitaAbecm_Error:
    "Currently the LOT start and end date for Cilta-cel/Ide-cel is the same. While Cilta-cel/Ide-cel is a single-day infusion, we ask that the LOT end date be entered as (i) a physician-defined end of LOT within patient record or (ii) the day before the next LOT start date otherwise. If neither (i) or (ii) are applicable (i.e., no subsequent LOT or formal end date), please list the end date as “Unknown”.",
  q262_BeforeLotEnd: "Date should be less than or equal to “LOT end date”",
  q262_BeyondSubsequentLot:
    "Date should be less than or equal to “subsequent LOT start date”",
  q262_StartBeyondAdminQ2225:
    "Date should be less than or equal to “maximum first/last administration date across Q22-Q25”",
  q262_EndBeforeAdminQ2225:
    "Date should be beyond or equal to “maximum first/last administration date across Q22-Q25”",
  q262_StartBeyondAdminQ26:
    "Date should be less than or equal to “maximum date of last administration in Q26/Q26.1”",
  q262_EndBeforeAdminQ26:
    "Date should be beyond or equal to “maximum date of last administration in Q26/Q26.1”",
  q262_DaraNotSelected:
    "Please complete all required treatment selections applicable to the 1L NDMM cohort.",
  // q262_CortiNotSelected:
  //   "Please select all treatment received options applicable for the 1L ndmm cohort treatment.",
  Q32c_LessThanEOF: "Date should be less than or equal to “end of follow up”",
  q32_MoreThanNxtLotStart:
    "Date should be less than or equal to “next lot start”",
  q263_C:
    "Please enter the date of daratumumab discontinuation (if known) or “Unknown” otherwise",
  q263_C_chain:
    "The date of daratumumab discontinuation is not consistent with the expected chronological order of the daratumumab administration, LOT, and follow-up dates reported elsewhere. Please review and revise as needed.",
  q26_chain:
    "The dates reported are not in the expected chronological order. The date of initial MM diagnosis should be on or before the NDMM index date (if applicable), followed by the Bispecifics/CAR-T index date, Bispecifics/CAR-T initiation date, Bispecifics/CAR-T end date, and end of follow-up. Please review and correct the reported dates as needed.",
  q261_chain:
    "The dates reported for this Bispecifics/CAR-T agent are not in the expected chronological order. The date of initial MM diagnosis should be on or before the NDMM index date (if applicable), followed by the Bispecifics/CAR-T index date, agent initiation date, agent end date, and end of follow-up. Please review and correct the reported dates as needed.",
};

export const CarTCharMsgs = {
  q41_Date_Empty:
    "Please enter the date of apheresis. This should be on or before the initiation date for CAR-T treatment. ",
  q41_Date_NotValid:
    "The date of apheresis entered is invalid; please enter a date of apheresis that is on or before the initiation date for CAR-T treatment. ",
  carTEmpty_Msg: "Please choose one of the provided options ",
  q42_Date_Not_Entered_Bridge:
    "Please enter date of therapy initiation; this should be on or after the date of apheresis and on or before both the lymphodepletion therapy date (if applicable) and the initiation date for CAR-T treatment. ",
  q42_Date_Not_Valid_Bridge:
    "The date of therapy initiation entered is invalid; please enter a date of therapy initiation that is on or after the date of apheresis and on or before both the lymphodepletion therapy date (if applicable) and the initiation date for CAR-T treatment.",

  q42_Date_Not_Entered_Lympo:
    "Please enter date of therapy initiation; this should be on or after both the date of apheresis and bridging therapy date (if applicable) and on or before the initiation date for CAR-T treatment. ",
  q42_Date_Not_Valid_Lympo:
    "The date of therapy initiation entered is invalid; please enter a date of therapy initiation that is on or after both the date of apheresis and bridging therapy date (if applicable) and on or before the initiation date for CAR-T treatment",
  q42_Date_Empty:
    "Please enter date of therapy initiation;this should be on or after both the date of apheresis and bridging therapy date (if appliacble) and on or before the intiation date for CAR-T treatment.",
  q43_Radio_Empty: "Please choose one of the provided options ",
  q43_Date_Empty:
    "Please enter the date of procedure; this should be on or after the initiation date for CAR-T treatment and on or before the end of this line of therapy, date of death (if applicable) and last patient encounter.",
  q43_Date_Not_Valid:
    "The date of procedure entered is invalid; please enter a date of procedure that is on or after the initiation date for CAR-T treatment and on or before the end of this line of therapy, date of death (if applicable) and last patient encounter. ",

  q43_1_Date_Not_Valid:
    "The date of tocilizumab administration entered is invalid; please enter a date of tocilizumab administration that is on or after the initiation date for CAR-T treatment and on or before the end of this line of therapy, date of death (if applicable) or last patient encounter.",

  q43_4_Date_Not_Valid:
    "The date of assessment entered is invalid; please enter a date of assessment that is on or after the Aphresis date for CAR-T treatment and on or before the end of this line of therapy, date of death (if applicable) and last patient encounter. ",

  q411A_Administration_Empty: "Please select site of administration",
  q411A_Utilization_Empty: "Please select single bag utilization",

  q43_1_Date_Empty:
    "Please enter the date of tocilizumab administration; this should be on or after the initiation date for CAR-T treatment and on or before the end of this line of therapy, date of death (if applicable) or last patient encounter.",
  q43_4_Date_Empty:
    "Please enter the date of assessment; this should be on or after the Aphresis date for CAR-T treatment and on or before the end of this line of therapy, date of death (if applicable) or last patient encounter.",
  q43_2_Date_Empty:
    "Please enter the date of Corticosteroid administration; this should be on or after the initiation date for CAR-T treatment and on or before the end of this line of therapy, date of death (if applicable) or last patient encounter.",
  q421A_C: "Please choose at least one of the provided options",
  q421A_C_txt: "Please enter the name for the other therapy received.",
  q421A_StartDate_Empty:
    "Please enter the start date of bridging; this should be on or before the lymphodepletion therapy date and initiation date for CAR-T treatment.",
  q421A_StartDate_Not_Valid:
    "The start date of bridging entered is invalid; please enter a start date of bridging that is on or before the lymphodepletion therapy date and initiation date for CAR-T treatment.",
  q421A_EndDate_Empty:
    "Please enter the end date of bridging; this should be on or before the lymphodepletion therapy date and initiation date for CAR-T treatment.",
  q421A_EndDate_Not_Valid:
    "The end date of bridging entered is invalid; please enter a start date of bridging that is on or before the lymphodepletion therapy date and initiation date for CAR-T treatment.",
  q421A_BRDate_Empty:
    "Please enter the date of best response assessment; this should be on or after the end date of bridging and before the lymphodepletion therapy date and initiation date for CAR-T treatment.",
  q421A_BRDate_Not_Valid:
    "The date of best response assessment entered is invalid; please enter a date of best response assessment that is on or after the start date of bridging and before the lymphodepletion therapy date and initiation date for CAR-T treatment.",
  q421A_AgentOverlap_Warning:
    "WARNING: multiple rows of bridging therapies have at least 1 agent in common. Please confirm that this agent was used for both bridging therapy regimens and that these are in fact two separate bridging therapy regimens. If confirmed, please proceed and ignore this warning.",
  q421A_BRDateAfterEnd_Warning:
    "WARNING: for at least one course of bridging therapy, you have reported a date of best response that falls <i><u>after</u></i> the end date of bridging therapy. Please ensure that this response assessment corresponds to the course of bridging therapy specifically or revise accordingly.",

  q43_2D_txt: "Please enter value for dose strength",
  q43_2_Date_Not_Valid:
    "The date of administration entered is invalid; please enter a date of administration that is on or after the Bispecifics/CAR-T index date – 30 days for CAR-T treatment and on or before the end of this line of therapy, date of death (if applicable) or last patient encounter.",
  q43_2E_Reason_AE:
    "Please choose one of the provided options for AE management",
  q43_2E_Reason_Neurologic:
    "Please choose one of the provided options for Neurologic Event",
  q43_2E_Reason_NeurologicTxt: "Please enter value for other neurologic event",
  q43_2D_RangeMGtxt:
    "Please enter a value greater than 0 and less than or equal to 4000.",
  q43_2D_RangeKGtxt:
    "Please enter a value greater than 0 and less than or equal to 60.",
  q43_4C_RangeULtxt:
    "Please enter a value greater or equal to 0 and less than or equal to 1000000.",
  q43_4C_RangeMMtxt:
    "Please enter a value greater or equal to 0 and less than or equal to 1000000.",
  q43_4C_RangeXLtxt:
    "Please enter a value greater or equal to 0 and less than or equal to 1000.",
  q43_4C_txt: "Please enter value for measurement",
};

export const hyperlinkTextQ21 = `
<div>
  <p style="text-align: left;">If the induction, consolidation, and maintenance therapies are not documented on the chart, the following definitions may be considered to infer:</p>
  <ul>
    <li style="text-align: left;"><u>Induction therapy</u>: defined as the initial 1L regimen received before transplant.</li>
    <li style="text-align: left;"><u>Consolidation therapy</u>: defined as the same regimen as the induction therapy used <b><u>after</u></b> transplant but <b><u>before</u></b> initiation of maintenance therapy.</li>
    <li style="text-align: left;"><u>Maintenance therapy</u>: defined as a regimen used after transplant and after consolidation therapy (if consolidation therapy is used). The following algorithm may be referenced by sites if needed. Specifically, a maintenance therapy can be any of the following:</li>
  </ul>
  <ol style="margin-left: 30px;">
    <li style="text-align: left;">If a regimen is followed by SCT*, then regimens (excluding CAR-T) initiated within 90 days after SCT and with duration ≤ 4 cycles (≤112 days) will be considered as MTs and will not advance the line.</li>
    <li style="text-align: left;">If a regimen lasting at least 4 cycles (≥112 days) is followed by a regimen within 90 days, and all drugs (excluding corticosteroids) in the subsequent regimen were used within the prior regimen, then the regimen will be considered as MT, and the line will not advance.<br/>
    If the main regimen is followed by SCT*, the allowed gap between regimens is extended to 183 days.</li>
    <li style="text-align: left;">Within a regimen, if an individual medication is discontinued, it will not advance the line.</li>
  </ol>
  <p style="margin-left: 40px; text-align: left;">* Regimen followed by SCT is defined as the SCT occurred after the last service date of any drug within the regimen (excluding corticosteroids), and the SCT occurred before (regimen end date + 90 days).</p>
</div>
`;

export const hyperlinkTextS5 = `
<div>
  <p style="text-align: left;">A line of therapy (LOT) can be determined or inferred based on information available in the chart. For sites that do not have LOT information, the following method may be used as reference for defining the 1st LOT, or 1L treatment. Specifically, initiation of 1L therapy is defined as the date on which the first NCCN-recommended medication for MM is given, either after the MM diagnosis date, or up to 14 days before it (corticosteroids do not affect this date).</p>
  <ul>
    <li style="text-align: left;">All NCCN-recommended medications for MM that are initiated within 60 days of the first medication start date should be considered as first-line therapy.</li>
    <li style="text-align: left;">Changes in any agent within 60 days of first medication start date is not considered a line of therapy change.</li>
  </ul>
</div>
`;

export const hyperlinkTextS5Radio = `
<div>
  <p style="text-align: left; font-weight: 500">Patients will still be considered as having received a line of treatment if they received all therapy drugs except for dexamethasone or when dexamethasone has been replaced by prednisone, prednisolone or methylprednisolone.</p>
</div>
`;

export const hyperlinkTextS7 = `
<div>
  <p style="text-align: left;">
    Transplant eligibility status may be determined based on information contained in the patient chart or physician notes. Transplant eligible (TE) patients include but are not necessarily limited to:
    <br />
    <ul>
    <li style="text-align: left;">
    Any patient who received autologous or allogeneic stem cell transplant (SCT) while on 1L treatment.</li>
    <li style="text-align: left;">
    Any patient who had stem cells collected and stored after initiating and while on 1L treatment.</li>
    </ul>
  </p>
</div>
`;

export const hyperlinkTextS9 = `
<div>
  <p style="text-align: left;">Systemic treatments exclude steroids, one-time monotherapy of cyclophosphamide, local radiotherapy to

stabilize bone lesions, etc</p>
</div>
`;

export const hyperlinkTextS11 = `
<div>
  <p style="text-align: left;">Patients will be considered if they received treatments as monotherapy or as combined therapy and in any line of treatment (except 1L) on or after the FDA approval date of each treatment. For those treated with CAR-T, patients are required to have received CAR-T infusion; patients who only received apheresis but did not receive infusion should not be considered eligible for the CAR-T cohorts.</p>
</div>
`;

export const hyperlinkTextAEReporting = `
<div>
  <p style="text-align: left;">
    If applicable, please report safety information for this patient according to the study protocol Section 5 at 
    <a href="http://www.janssensafety.com" target="_blank" rel="noopener noreferrer">
      www.janssensafety.com</a>
  </p>
</div>
`;

export const hyperlinkTextQ19 = `
<div>
  <p style="text-align: left;">
    This can be a visit, telehealth consultation, lab test, imaging report, or any other recorded date in the patient chart prior to or on the date you last edited on for this chart.
  </p>
</div>
`;

export const hyperlinkTextQ36Tecvayli = `
<div>
  <p style="text-align: left; font-weight: normal;">
    Step-up and weekly dosing for <b>TECVAYLI® (teclistamab-cqyv)</b> and <b>TALVEY<sup>TM</sup> (talquetamab-tgvs)</b> should be based on the recommended dosing schedule according to the prescription label (dosing information below up-to-date as of November 5<sup>th</sup>, 2025):
  </p>
  <table border="1" style="width:100%; border-collapse: collapse; table-layout: fixed;">
    <tr>
      <td colspan="4" style="border: 1px solid black; text-align: center;">TECVAYLI® Recommended Dosing Schedule<b></td>
    </tr>
    <tr>
      <td style="border: 1px solid black; text-align: center;">Dosing Schedule</td>
      <td style="border: 1px solid black; text-align: center;">Day</td>
      <td colspan="2" style="border: 1px solid black; text-align: center;">Dose</td>
    </tr>
  <tr>
    <td rowspan="3" style="border: 1px solid black; text-align: center;">Step-up dosing schedule</td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Day 1</td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Step-up dose 1 </td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">0.06 mg/kg </td>
  </tr>
  <tr>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Day 4 </td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Step-up dose 2 </td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">0.30 mg/kg </td>
  </tr>
  <tr>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Day 7 </td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">1<sup>st</sup> treatment dose</td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">1.50 mg/kg </td>
  </tr>
 
    <tr>
      <td style="border: 1px solid black; text-align: center;">Treatment dosing schedule </td>
      <td style="border: 1px solid black; text-align: center; font-weight: normal;">One week after first treatment dose and weekly thereafter</td>
      <td style="border: 1px solid black; text-align: center; font-weight: normal;">Subsequent treatment doses</td>
      <td style="border: 1px solid black; text-align: center; font-weight: normal;">1.50 mg/kg once weekly</td>

    </tr>
    
  </table>

    <p style="text-align: left; font-size: 12px; font-weight: normal;">
    <sup>a</sup>Based on actual body weight.<br/>
    <sup>b</sup>Dose may be administered between 2-4 days after the previous dose and may be given up to 7 days after the previous dose to allow for resolution of adverse reactions<br/>
    <sup>c</sup>Maintain a minimum of 6 days between weekly doses<br/>
    <sup>d</sup>Dose may be administered between 2 to 7 days after step-up dose 3.<br/>
    <sup>e</sup>Maintain a minimum of 12 days between biweekly (every 2 weeks) doses.<br/>
    <sup>f</sup>Responders only Week 25 onward.<br/>
    <sup>g</sup>In patients who have maintained the response following 24 weeks of treatment at the biweekly dosing schedule.<br/>
  </p>
</div>
`;

export const hyperlinkTextQ36Talvey = `
<div>
  <p style="text-align: left; font-weight: normal;">
    Step-up and weekly dosing for <b>TECVAYLI® (teclistamab-cqyv)</b> and <b>TALVEY<sup>TM</sup> (talquetamab-tgvs)</b> should be based on the recommended dosing schedule according to the prescription label (dosing information below up-to-date as of November 5<sup>th</sup>, 2025):
  </p>
  <table border="1" style="width:100%; border-collapse: collapse; table-layout: fixed;">
    <tr>
      <td colspan="4" style="border: 1px solid black; text-align: center;">TALVEY<sup>TM</sup> Recommended Weekly (Every 1 Week) Dosing Schedule</td>
    </tr>
    <tr>
      <td style="border: 1px solid black; text-align: center;">Dosing Schedule</td>
      <td style="border: 1px solid black; text-align: center;">Day</td>
      <td colspan="2" style="border: 1px solid black; text-align: center;">Dose<sup>a</sup></td>
    </tr>
  <tr>
    <td rowspan="3" style="border: 1px solid black; text-align: center; ">Step-up dosing schedule</td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Day 1</td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Step-up dose 1</td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">0.01 mg/kg</td>
  </tr>
  <tr>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Day 4<sup>b</sup></td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Step-up dose 2</td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">0.06 mg/kg</td>
  </tr>
  <tr>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Day 7<sup>b</sup></td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">1<sup>st</sup> treatment dose</td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">0.40 mg/kg</td>
  </tr>
 
    <tr>
      <td style="border: 1px solid black; text-align: center;">Treatment dosing schedule </td>
      <td style="border: 1px solid black; text-align: center; font-weight: normal;">One week after first treatment dose and weekly thereafter<sup>c</sup></td>
      <td style="border: 1px solid black; text-align: center; font-weight: normal;">Subsequent treatment doses</td>
      <td style="border: 1px solid black; text-align: center; font-weight: normal;">0.40 mg/kg once weekly</td>

    </tr>
    
  </table>

  <table border="1" style="width:100%; border-collapse: collapse; table-layout: fixed;">
    <tr>
      <td colspan="4" style="border: 1px solid black; text-align: center;">TALVEY<sup>TM</sup> Recommended Biweekly (Every 2 Weeks) Dosing Schedule </td>
    </tr>
    <tr>
      <td style="border: 1px solid black; text-align: center;">Dosing Schedule</td>
      <td style="border: 1px solid black; text-align: center;">Day</td>
      <td colspan="2" style="border: 1px solid black; text-align: center;">Dose<sup>a</sup></td>
    </tr>
  <tr>
    <td rowspan="4" style="border: 1px solid black; text-align: center;">Step-up dosing schedule</td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Day 1</td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Step-up dose 1</td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">0.01 mg/kg</td>
  </tr>
  <tr>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Day 4<sup>b</sup></td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Step-up dose 2</td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">0.06 mg/kg</td>
  </tr>
  <tr>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Day 7<sup>b</sup></td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Step-up dose 3</td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">0.40 mg/kg</td>
  </tr>
  <tr>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">Day 10<sup>d</sup></td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">1<sup>st</sup> treatment dose</td>
    <td style="border: 1px solid black; text-align: center; font-weight: normal;">0.80 mg/kg</td>
  </tr>
 
    <tr>
      <td style="border: 1px solid black; text-align: center;">Treatment dosing schedule </td>
      <td style="border: 1px solid black; text-align: center; font-weight: normal;">Two weeks after first treatment dose and every two weeks thereafter<sup>e</sup></td>
      <td style="border: 1px solid black; text-align: center; font-weight: normal;">Subsequent treatment doses</td>
      <td style="border: 1px solid black; text-align: center; font-weight: normal;">0.80 mg/kg every 2 weeks</td>

    </tr>
    
  </table>


  <p style="text-align: left; font-size: 12px; font-weight: normal;">
    <sup>a</sup>Based on actual body weight.<br/>
    <sup>b</sup>Dose may be administered between 2-4 days after the previous dose and may be given up to 7 days after the previous dose to allow for resolution of adverse reactions<br/>
    <sup>c</sup>Maintain a minimum of 6 days between weekly doses<br/>
    <sup>d</sup>Dose may be administered between 2 to 7 days after step-up dose 3.<br/>
    <sup>e</sup>Maintain a minimum of 12 days between biweekly (every 2 weeks) doses.<br/>
     <sup>f</sup>Responders only Week 25 onward.<br/>
    <sup>g</sup>In patients who have maintained the response following 24 weeks of treatment at the biweekly dosing schedule.<br/>
  </p>
</div>
`;

export const hyperlinkTextStandardIMWGReportingCriteria = `
<div>
  <p style="text-align: left; font-weight: normal;">
    <b>Standard IMWG Reporting Criteria</b>
  </p>
  <table border="1" style="width:100%; border-collapse: collapse; table-layout: fixed;">
    <tr>
      <td style="border: 1px solid black; text-align: left; padding: 10px;"><b>Response</b></td>
      <td style="border: 1px solid black; text-align: left; padding: 10px;"><b>Definition</b></td>
    </tr>
    <tr>
      <td style="border: 1px solid black; text-align: left; padding: 10px; font-weight: normal;">Stringent complete response (sCR)</td>
      <td style="border: 1px solid black; text-align: left; padding: 10px; font-weight: normal;">Complete response as defined below plus normal free light chains (FLC) ratio and absence of clonal cells in bone marrow biopsy by immunohistochemistry (κ/λ ratio ≤ 4:1 or ≥ 1:2 for κ and λ patients respectively, after counting ≥ 100 plasma cells)</td>
    </tr>
    <tr>
      <td style="border: 1px solid black; text-align: left; padding: 10px; font-weight: normal;">Complete response (CR)</td>
      <td style="border: 1px solid black; text-align: left; padding: 10px; font-weight: normal;">Negative immunofixation on the serum and urine and disappearance of any soft tissue plasmacytomas and &lt; 5% plasma cells in bone marrow aspirates</td>
    </tr>
    <tr>
      <td style="border: 1px solid black; text-align: left; padding: 10px; font-weight: normal;">Very good partial response (VGPR)</td>
      <td style="border: 1px solid black; text-align: left; padding: 10px; font-weight: normal;">Serum and urine M-protein detectable by immunofixation but not on electrophoresis or ≥ 90% reduction in serum M-protein plus urine M-protein level &lt; 100 mg per 24 h</td>
    </tr>
    <tr>
      <td style="border: 1px solid black; text-align: left; padding: 10px; font-weight: normal;">Partial response (PR)</td>
      <td style="border: 1px solid black; text-align: left; padding: 10px; font-weight: normal;">≥ 50% reduction of serum M-protein plus reduction in 24-h urinary M-protein by ≥ 90% or to &lt; 200mg per 24h. If the serum and urine M-protein are unmeasurable, a ≥ 50% decrease in the difference between involved and uninvolved FLC levels is required in place of the M-protein criteria. If serum and urine M-protein are unmeasurable, and serum-free light assay is also unmeasurable, ≥ 50% reduction in plasma cells is required in place of M-protein, provided baseline bone marrow plasma-cell percentage was ≥ 30%. In addition to these criteria, if present at baseline, a ≥ 50% reduction in the size (sum of the products of the maximal perpendicular diameters [SPD] of measured lesions) of soft tissue plasmacytomas is also required.</td>
    </tr>
    <tr>
      <td style="border: 1px solid black; text-align: left; padding: 10px; font-weight: normal;">Minimal response (MR)</td>
      <td style="border: 1px solid black; text-align: left; padding: 10px; font-weight: normal;">≥ 25% but ≤ 49% reduction of serum M-protein and reduction in 24-h urine M-protein by 50%-89%. In addition to the above listed criteria, if present at baseline, a 25%-49% reduction in SPD of soft tissue plasmacytomas is also required.</td>
    </tr>
    <tr>
      <td style="border: 1px solid black; text-align: left; padding: 10px; font-weight: normal;">Stable disease (StD)</td>
      <td style="border: 1px solid black; text-align: left; padding: 10px; font-weight: normal;">Stability of disease is described by providing the time-to-progression estimates. Not meeting criteria for complete response, very good partial response, partial response, minimal response, or progressive disease.</td>
    </tr>
    <tr>
      <td style="border: 1px solid black; text-align: left; padding: 10px; font-weight: normal;">Progressive disease (PD)</td>
      <td style="border: 1px solid black; text-align: left; padding: 10px; font-weight: normal;">Any one or more of the following criteria:
        <ul style="list-style-type: disc; padding-left: 20px;">
          <li style="text-align: left; font-weight: normal;">
            Increase of 25% from lowest confirmed response value on or more of the following criteria:
            <ul style="list-style-type: circle; padding-left: 20px;">
              <li style="text-align: left; font-weight: normal;">Serum M-protein (absolute increase must be ≥ 0.5g/dL)</li>
              <li style="text-align: left; font-weight: normal;">Serum M-protein (increase ≥ 1 g/dL, if the lowest M component was ≥ 5 g/dL)</li>
              <li style="text-align: left; font-weight: normal;">Urine M-protein (absolute increase must be ≥ 200 mg/24 h)</li>
            </ul>
          </li>
          <li style="text-align: left; font-weight: normal;">In patients without measurable serum and urine M-protein levels, the difference between involved and uninvolved FLC levels (absolute increase must be > 10 mg/dL)</li>
          <li style="text-align: left; font-weight: normal;">In patients without measurable serum and urine M-protein levels and without measurable involved FLC levels, bone marrow plasma-cell percentage irrespective of baseline status (absolute increase must be ≥ 10%)</li>
          <li style="text-align: left; font-weight: normal;">Appearance of a new lesion(s), ≥ 50% increase from nadir in SPD of >1 lesion, or ≥ 50% in the longest diameter of a previous lesion > 1 cm in short axis</li>
          <li style="text-align: left; font-weight: normal;">≥ 50% increase in circulating plasma cells (minimum of 200 cells per μL) if this is the only measure of disease</li>
        </ul>
      </td>
    </tr>
  </table>

  <p style="font-weight: normal; text-align: left">
    FLC: Free light chain; IMWG: International Myeloma Working Group.
  </p>
</div>
`;

export const hyperlinkTextLineOfTherapy = `
<div>
  <p style="text-align: left;" font-weight: normal;">
    <b>Line of Therapy Algorithm<b>
  </p>
  <p style="text-align: left; font-weight: normal;">
    A line of therapy (LOT) can be determined or inferred based on information available in the chart. For sites that do not have LOT information, the following method may be used as reference.
  </p>
  <p style="text-align: left; font-weight: normal;">
    <b>Defining Regimens and LOTs</b>
  </p>
  <p style="text-align: left; font-weight: normal;">
    Each regimen will be defined by a start date, an end date, and a distinct regimen, made up of one or more drugs. A patient may receive multiple treatment regimens in sequence during the course of their treatment.  
  </p>
  <p style="text-align: left; font-weight: normal;">
    <b>Regimen:</b> A regimen is formed by one or several NCCN-recommended medications for MM (see Table below for MM Drugs) identified from  both structured and unstructured EMR during the first 60 days following the regimen initiation.  
  </p>
  <p style="text-align: left; font-weight: normal;">
  Each regimen will end on either the discontinuation date of all drugs within the regimen (except for corticosteroids), or the date of treatment change (including augmentation and switching), whichever happens first. The date of treatment change will be the initiation date of the next line of therapy regimen as defined below. Changes in any agent (‘targeted’ or chemo) within 60 days of first treatment is not considered a line change.
  </p>
  <p style="text-align: left; font-weight: normal;">
  Corticosteroids do not affect LOT increments, start dates, or end dates. A corticosteroid will be considered part of a regimen if there is at least 1 day overlap with the regimen’s first 60 days.
  </p>
  <p style="text-align: left; font-weight: normal;">
  If a regimen is discontinued and then resumed within 90 days, then this will be treated as the same regimen.  
  </p>
  <p style="text-align: left; font-weight: normal;">
  <b>Gap:</b> Gap is calculated as the days elapsed between the last day of current dispensing/administration and its subsequent dispensing/administration.  
  </p>
  <p style="text-align: left; font-weight: normal;">
  <b>Discontinuation of individual medication:</b> Discontinuation of an individual medication will be defined as the failure to refill the medication of interest within the maximum allowed gap (MAG) of 90 days after the expiration  the last day of dispensing/administration. For belantamab, MAG is 183 days instead of 90 days due to adverse event management. The discontinuation date of the medication will be calculated as the last day of dispensing/administration.  
  </p>
  <p style="text-align: left; font-weight: normal;">
  If a stem cell transplant (SCT) occurred between two drug segments, then they will be treated as the same drug segment if all of the following criteria are met: (1) the SCT occurred on or after the last service date within the prior drug segment, (2) the SCT occurred on or before the end of the MAG after the prior drug segment, and (3) the next drug segment began within 6 months (183 days) after the SCT.  
  </p>
  <p style="text-align: left; font-weight: normal;">
  Melphalan and cyclophosphamide drug segments with duration <28 days will be excluded as preparation for SCT, so as not to advance the line.
  </p>
  <p style="text-align: left; font-weight: normal;">
  <b>Augmentation:</b> An augmentation will be defined as receiving a new medication of interest at least 60 days prior to discontinuing any of the medications included in the current regimen. The date initiating the new medication will be considered as the augmentation date. Changing between daratumumab and daratumumab/hyaluronidase does not count as augmentation.
  </p>
  <p style="text-align: left; font-weight: normal;">
  <b>Switch:</b> A switch will be defined as receiving a new medication of interest with at least one medication of the current regimen discontinued prior to or within 60 days after the initiation of the new medication. The initiation date of the new medication will be considered as the switch date. Changing between daratumumab and daratumumab/hyaluronidase does not count as a switch.
  </p>
  <p style="text-align: left; font-weight: normal;">
  <b>Maintenance therapies:</b> Three types of maintenance therapies (MTs) are allowed.
  </p>
 
  <ol style="list-style-type: none; text-align: left; font-weight: normal;">
    <li>(1) If a regimen is followed by SCT*, then regimens (excluding CAR-T) initiated within 90 days after SCT and with a duration ≤ 4 cycles (≤112 days) will be considered as MTs and will not advance the line.</li>
    <li>(2) If a regimen lasting at least 4 cycles (≥112 days) is followed by a regimen within 90 days, and all drugs (excluding corticosteroids) in the subsequent regimen were used within the prior regimen, then the regimen will be considered as MT, and the line will not advance. If the main regimen is followed by SCT*, the allowed gap between regimens is extended to 183 days.</li>
    <li>(3) Within a regimen, if an individual medication is discontinued, it will not advance the line.</li>
  </ol>
 
  <p style="text-align: left; font-weight: normal;">
  * Regimen followed by SCT is defined as the SCT occurred after the last service date of any drug within the regimen (excluding corticosteroids), and the SCT occurred before (regimen end date + 90 days).
  </p>
 
  <p style="text-align: left; font-weight: normal;">
  <b>Chemotherapy:</b> The addition of chemotherapy agents (see Table below for MM Drugs) initiates a new regimen.
  </p>
 
  <p style="text-align: left; font-weight: normal;">
  <b>Discontinuation of a regimen:</b> Discontinuation of a regimen is defined as discontinuation of all medications in the regimen (excluding corticosteroids), or treatment change (including augmentation and switching), whichever occurs first. For example, if no treatment change happens, discontinuation of the regimen will be the latest discontinuation date of all non-corticosteroid medications included in the regimen. If only a corticosteroid remains after discontinuation of other therapies in the regimen, that will be considered a regimen discontinuation (corticosteroids do not extend the regimen end date). Whereas if a treatment change occurs prior to the latest discontinuation date, the date of treatment change will be considered as the discontinuation date of the regimen.
  </p>
 
  <p style="text-align: left; font-weight: normal;">
  There is an exception that if a patient used a maintenance therapy (see definition above) within 6 months after a SCT, regardless of whether the MT drugs were part of the initial regimen or not, such “switching” will NOT be considered as switching and thus will NOT trigger LOT increase. The discontinuation date for the regimen will be extended to the discontinuation of the MT.
  </p>
 
  <p style="text-align: left; font-weight: normal;">
  <b>CAR-T LOT:</b> For CAR-T patients, therapy between apheresis and CAR-T infusion is considered bridging therapy. If a LOT starts on or after apheresis and CAR-T infusion occurs >60 days later, the LOTs will be combined to include both bridging and CAR-T infusion.  
  </p>
 
  <p style="text-align: left; font-weight: normal;">
  <b>Line of Therapy Increase:</b> Induction therapy preceding SCT is a new LOT, however SCT itself is not a new LOT. Multiple SCTs are permitted with minimum 6-month gap between SCTs per patient. A treatment change (including augmentation and switching) or initiation of a new regimen after discontinuation of a previous regimen will increase the LOT (with the exception of maintenance therapy and CAR-T LOT, as described above).  
  </p>
 
 
  <p style="text-align: left;" font-weight: normal;">
    MM Drugs: 
  </p>
 
 
     



  <table border="1" style="width:100%; border-collapse: collapse; table-layout: fixed;" class="line-of-therapy">
    <tr>
        <td style="border: 1px solid black; text-align: center;">Drug Class</td>
        <td style="border: 1px solid black; text-align: center;">Drug Name</td>
        <td style="border: 1px solid black; text-align: center;">Drug Molecule</td>
        <td style="border: 1px solid black; text-align: center;">ROA</td>
        <td style="border: 1px solid black; text-align: center;">Imputed Days Supply*</td>
    </tr>
 
    <tr>
        <td rowspan="3" style="border: 1px solid black; word-wrap: break-word; font-weight: normal;">
            Immunomodulatory (iMiD)
        </td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Thalidomide (Synovir, Thalomid)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Oral</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">28 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Lenalidomide (Revlimid)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Oral</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">28 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Pomalidomide (Pomalyst)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Oral</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">28 days</td>
    </tr>
 
    <tr>
        <td rowspan="3" style="border: 1px solid black; word-wrap: break-word; font-weight: normal;">
            Proteasome Inhibitor (PI)
        </td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Bortezomib (Velcade)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">SQ, IV</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">14 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Carfilzomib (Kyprolis)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">IV</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">7 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Ixazomib (Ninlaro)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Oral</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">28 days</td>
    </tr>
 
    <tr>
        <td rowspan="3" style="border: 1px solid black; word-wrap: break-word; font-weight: normal;">
            Anti-CD38 Monoclonal Antibody (MAB)
        </td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Daratumumab (Darzalex)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Biologics</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">IV</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">14 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Daratumumab (Darzalex Faspro)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Biologics</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">SQ</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">14 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Isatuximab (Sarclisa)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Biologics</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">IV</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">28 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; word-wrap: break-word; font-weight: normal;">
          Other Monoclonal Antibody (MAB)
        </td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Elotuzumab (Empliciti)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">Biologics</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">IV</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align: left">14 days</td>
    </tr>
 
 
    <tr>
        <td style="border: 1px solid black; text-align: center; font-weight: normal;">Histone Deacetylase (HDAC) Inhibitor</td>
        <td style="border: 1px solid black; text-align: left; font-weight: normal; break-word;">Panobinostat (Farydak)</td>
        <td style="border: 1px solid black; text-align: left; font-weight: normal; break-word;">Small Molecule </td>
        <td style="border: 1px solid black; text-align: left; font-weight: normal; break-word;">Oral</td>
        <td style="border: 1px solid black; text-align: left; font-weight: normal; break-word;">21 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; text-align: center; font-weight: normal;">Nuclear Export Inhibitor (INE)</td>
        <td style="border: 1px solid black; text-align: left; font-weight: normal; break-word; ">Selinexor (Xpovio)</td>
        <td style="border: 1px solid black; text-align: left; font-weight: normal; break-word; ">Small Molecule </td>
        <td style="border: 1px solid black; text-align: left; font-weight: normal; break-word; ">Oral</td>
        <td style="border: 1px solid black; text-align: left; font-weight: normal; break-word; ">7 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; text-align: center; font-weight: normal;">B-cell Lymphoma 2 <br/> (BCL-2) Inhibitor</td>
        <td style="border: 1px solid black; text-align: left; font-weight: normal; break-word;">Venetoclax (Venclexta)</td>
        <td style="border: 1px solid black; text-align: left; font-weight: normal; break-word;">Small Molecule </td>
        <td style="border: 1px solid black; text-align: left; font-weight: normal; break-word;">Oral</td>
        <td style="border: 1px solid black; text-align: left; font-weight: normal; break-word;">1 day</td>
    </tr>
 
 
    <tr>
        <td rowspan="8" style="border: 1px solid black; word-wrap: break-word; font-weight: normal;">
          Chemotherapy (Chemo) 
        </td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Cyclophosphamide (Cytoxan)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">IV, Oral</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">14 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Melphalan (Alkeran)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">IV, Oral</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">14 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Doxorubicin (Adriamycin, Doxil)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">IV</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">21 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Etoposide (Toposar, VePesid)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">IV, Oral</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">5 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Cisplatin (Platinol)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">IV</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">5 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Bendamustine (Treanda, Belrapzo, Bendeka, generic)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">IV</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">28 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Cytarabine/Pf</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">IV</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">14 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Vincristine (rarely used)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">IV, Oral</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">7 days</td>
    </tr>
 
 
    <tr>
        <td rowspan="4" style="border: 1px solid black; word-wrap: break-word; font-weight: normal;">
        Corticosteroid
        </td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Prednisone</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Oral</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">1 day</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Prednisolone</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Oral</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">1 day</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Dexamethasone</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Small Molecule</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">IV, Oral</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">1 day</td>
    </tr>
 
    <tr>
    <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Methylprednisolone</td>
    <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Small Molecule</td>
    <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">IV, Oral</td>
    <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">1 day</td>
</tr>
 
    <tr>
        <td rowspan="6" style="border: 1px solid black; word-wrap: break-word; font-weight: normal;">
          B-cell maturation antigen (BCMA) targeted therapy
        </td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Belantamab mafodotin-blmf (Blenrep)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Biologics</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">IV</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">21 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Idecabtagene vicleucel (Abecma) </td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Car-T Cell Therapy </td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">IV</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">1 day</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Ciltacabtagene autoleucel (Carvykti)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Car-T Cell Therapy</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">IV</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">1 day</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Teclistamab (Tecvayli)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Biologics </td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">SQ</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">7 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Elranatamab (Elrexfio)</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Biologics </td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">SQ</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">14 days</td>
    </tr>
 
    <tr>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Linvoseltamab</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">Biologics </td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">SQ</td>
        <td style="border: 1px solid black; font-weight: normal; word-wrap: break-word; text-align:left">TBD</td>
    </tr>
 
 
    <tr>
        <td style="border: 1px solid black; text-align: center; font-weight: normal;">
        G protein–coupled receptor, class C, group 5, member D (GPRC5D) targeted therapy 
        </td>
        <td style="border: 1px solid black; text-align: center; font-weight: normal; text-align:left">Talquetamab (Talvey)</td>
        <td style="border: 1px solid black; text-align: center; font-weight: normal; text-align:left">Biologics</td>
        <td style="border: 1px solid black; text-align: center; font-weight: normal; text-align:left">SQ</td>
        <td style="border: 1px solid black; text-align: center; font-weight: normal; text-align:left">14 days</td>
    </tr> 
</table>
 
 
 
</div>
`;
export const predefinedReasons = [
  {
    agentid: null,
    reasonid: 1,
    reasonName: "Patient death",
    reasonText: null,
    supscripttext: "",
    isSelected: false,
    reasonUnk: null,
  },
  {
    agentid: null,
    reasonid: 2,
    reasonName: "Adverse event",
    reasonText: null,
    supscripttext: "",
    isSelected: false,
    reasonUnk: null,
  },
  {
    agentid: null,
    reasonid: 3,
    reasonName: "Disease progression",
    reasonText: null,
    supscripttext: "",
    isSelected: false,
    reasonUnk: null,
  },
  {
    agentid: null,
    reasonid: 4,
    reasonName: "Insufficient response without progression",
    reasonText: null,
    supscripttext: "",
    isSelected: false,
    reasonUnk: null,
  },
  {
    agentid: null,
    reasonid: 5,
    reasonName: "Cost or insufficient insurance coverage",
    reasonText: null,
    supscripttext: "",
    isSelected: false,
    reasonUnk: null,
  },
  {
    agentid: null,
    reasonid: 6,
    reasonName: "End of treatment plan",
    reasonText: null,
    supscripttext: "",
    isSelected: false,
    reasonUnk: null,
  },
  {
    agentid: null,
    reasonid: 7,
    reasonName: "Achieved CR or better (per the 2016 IMWG criteria)",
    reasonText: null,
    supscripttext: "",
    isSelected: false,
    reasonUnk: null,
  },
  {
    agentid: null,
    reasonid: 8,
    reasonName: "Achieved (sustained) MRD negativity (10",
    reasonText: null,
    supscripttext: "-5)",
    isSelected: false,
    reasonUnk: null,
  },
  {
    agentid: null,
    reasonid: 9,
    reasonName: "Achieved (sustained) MRD negativity (10",
    reasonText: null,
    supscripttext: "-6)",
    isSelected: false,
    reasonUnk: null,
  },
  {
    agentid: null,
    reasonid: 10,
    reasonName: "Achieved VGPR or better (per the 2016 IMWG criteria)",
    reasonText: null,
    supscripttext: "",
    isSelected: false,
    reasonUnk: null,
  },
  {
    agentid: null,
    reasonid: 11,
    reasonName: "Suboptimal response (PR or SD) (per the 2016 IMWG criteria)",
    reasonText: null,
    supscripttext: "",
    isSelected: false,
    reasonUnk: null,
  },
  {
    agentid: null,
    reasonid: 12,
    reasonName: "Patient's decision (if none of the above)",
    reasonText: null,
    supscripttext: "",
    isSelected: false,
    reasonUnk: null,
  },
  {
    agentid: null,
    reasonid: 13,
    reasonName: "Physician's decision (if none of the above)",
    reasonText: null,
    supscripttext: "",
    isSelected: false,
    reasonUnk: null,
  },
  {
    agentid: null,
    reasonid: 14,
    reasonName: "Other, please specify: ",
    reasonText: null,
    supscripttext: "",
    isSelected: false,
    reasonUnk: null,
  },
];
export const NonCohortTreatment_Msgs = {
  //Ndmm
  Q27a: "Please choose one of the provided options",
  Q27b: "Please enter the Start date of LOT (if known) or “Unknown” otherwise",
  // Q27b_LessThanLot3:
  //   "“NDMM 2nd LOT start” should be less than or equal to “NDMM 3rd LOT start”",
  q27b_LessThan2ndLot:
    "Date should be on or after the start date of the 2nd LOT",
  Q27b_DateBeforeIndex:
    "Date should be on or after the latter of the index date and date of last administration of all 1L agents (exclude dexamethasone, prednisone, and prednisolone dates of first and last administration)",
  Q27b_LessThanEOF:
    "Date should be on or before the date of last patient encounter and/or date of death.",
  Q27c: "Please choose one of the provided options",
  Q27d: "Please choose at least one of the provided options or “Unknown”",
  Q27d_txt: "Please enter the name of the prescribed treatment",
  Q27b_2LStartDate:
    "The 2L Start Date must be on or after the latest Last Administration Date reported in Q22–Q25.",
  Q27b_3LStartDate:
    "The latest administration date in Q22–Q25 must be on or before the latest Lot 2 administration date, or the 2L Start Date must be on or before the 3L Start Date.",
  Q27d_AgentOverlapWarning:
    "WARNING: at least 1 of the agents received on 2L matches an agent received and discontinued on 1L. Please confirm that the same agent(s) was used on both 1L and 2L and that 2L is a new unique line of therapy. If 2L refers to consolidation or maintenance therapy while on 1L, this should be updated in Q21.1-Q25. If 1L and 2L are correctly specified, please proceed and ignore this warning.",

  q28_C_before_q27_B_err:
    "Date should be on or after the start date of the 2nd LOT",
  q28_C_before_lot2_admin_err:
    "Date should be on or after the latest administration date reported in Q26/Q26.1 for the 2nd LOT.",
  q28_C_beyond_ndmm_3rd_LOT_err:
    "Date should be less than or equal to “NDMM 3rd LOT Start”",
  q28b_InvalidCombo: "“3rd LOT” is specified",

  q29_C_before_q27_B_err:
    "Date should be on or after the start date of the 3rd LOT",
  q29_C_before_lot3_admin_err:
    "Date should be on or after the latest administration date reported in Q26/Q26.1 for the 3rd LOT.",
  q29_C_beyond_next_lot_err:
    "Date should be less than or equal to “4th LOT start”",
  q29_F_B_ongoing_err:
    "“No” must be specified in “Discontinued treatment for this LOT” when “3rd LOT still ongoing” is specified.",
  q29_F_B_subsequent_err:
    "“Yes” must be specified in “Discontinued treatment for this LOT” when “Yes, patient had a 4th LOT” is specified.",

  //Q29 uses Q32 msgs
  Q30: "Please choose at least one of the provided options",
  //Bispecifics
  Q31a: "Please choose one of the provided options",
  Q31b: "Please enter the Start date of LOT (if known) or “Unknown” otherwise",
  q31_B_beyond_eof_err:
    "Date should be on or before the date of last patient encounter and/or date of death.",
  q31_B_before_index_err:
    "Date should be after the initiation date for this treatment",
  q31_B_chain_err:
    "Please ensure that the Bispecifics/CAR-T start date is on or before the Bispecifics/CAR-T end date, which is on or before the start date of this subsequent LOT, which is on or before the next highest LOT start date (if available), and on or before the end of follow-up.",
  q31_B_max_admin_err:
    "The start date of this subsequent LOT must be on or after the latest administration date reported in Q26/Q26.1/Q26.2 for all prior RRMM LOTs. Please review and update the LOT start date or the applicable administration dates.",
  Q31c: "Please choose one of the provided options",
  Q31d: "Please choose at least one of the provided options",
  Q31d_txt: "Please enter the name of the prescribed treatment",
  Q31d_agentDiscontinuedWarning:
    "WARNING: at least 1 of the agents listed on this subsequent line of therapy matches the line of therapy prior. Please confirm that the same agent(s) were used on both LOTs and that this subsequent LOT is a unique line of therapy. If the subsequent LOT was incorrectly specified, please update responses in Q26-Q26.2 or Q31. If all LOTs are correctly specified, please proceed and ignore this warning.",

  Q32b: "Please choose one of the provided options",
  Q32c: "Please enter the date of discontinuation of LOT (if known) or “Unknown” otherwise",
  Q32c_LessThanEOF: "Date should be less than or equal to “end of follow up”",
  q32_MoreThanNxtLotStart:
    "Date should be less than or equal to “next lot start”",
  q32_C_beyond_next_lot_err:
    "Date should be less than or equal to “next lot start”",
  Q32d: "Please choose one of the provided options",
  Q32e: "Please choose at least one of the provided options",
  Q32f: "Please choose one of the provided options",
  Q32f_Invalid1:
    "Wrong combination “No” is specified in “Discontinued treatment for this LOT”",
  Q32f_Invalid2:
    "Please revise; patient cannot have 3rd LOT ongoing if this LOT was discontinued.",
  q32_F_B_ongoing_err:
    "“No” must be specified in “Discontinued treatment for this LOT” when “This LOT is still ongoing” is specified.",
  q32_F_B_subsequent_err:
    "“Yes” must be specified in “Discontinued treatment for this LOT” when “Yes, patient had a subsequent LOT” is specified.",

  Q33: "Please choose at least one of the provided options or “Unknown”",
};

export const NDMMSCTCharecteristics_Msgs = {
  Q34Empty: "Please choose at least one of the provided options or “Unknown” ",
  Q34Text: "(please enter the name of the prescribed treatment)",
  Q35Empty: "Please choose one of the provided options",
  Q35a: "Please enter the date of SCT transplant (if known) or unknown otherwise",
  Q35aValid:
    "The date of stem cell transplant (SCT) is invalid. Please ensure that the date of SCT falls on or after the date of last administration of all induction therapy agents or the 1L NDMM treatment cohort and on or before the dates of first administration of consolidation and maintenance therapy agents.",
  Q35c: "Please enter the number of stem cells/kg (in millions) between 0 and 100.",
  Q35d: "Please enter the number of stem cells (in millions) between 0 and 100.",
  Q35e: "Please enter the number of mobilization attempts between 0 and 20",
  Q35f: "(please enter the name of the prescribed treatment)",
};

export const CohortDefiningTreatment_Msgs = {
  Q19Empty:
    "Please enter the date of last patient encounter; this should fall on or after the date of treatment initiation and on or before the last edited on date",
  Q19DateValidError:
    "The date of last patient encounter is invalid; please enter a date on or after the date of treatment initiation for all eligible cohorts and on or before the last edited on date.",
  Q20Empty:
    "Please enter the date of death; this should be on or after the date of last patient encounter and on or before the last edited on date.",

  Q20EmptyDate:
    "Please enter the date of death; this should be on or after the date of last patient encounter and on or before the last edited on date.",
  Q20DateValidError:
    "The date of death is invalid; please enter a date on or after the date of last patient encounter and on or before the last edited on date.",
  Q19EncounterDateValid:
    "Date of last encounter must be after MM diagnosis date (see question S3) and Date of birth",
  Q20DeathDateValid:
    "Date of death must be after MM diagnosis date (see question S3)",
};

export const AdverseEvents_Msgs = {
  RadioNoSelection: "Please choose one of the provided options",
  //58
  Q58AssessmentEmpty: "Please choose one of the provided options",
  Q58DateEmpty: "Please enter the date of weight assessment",
  Q58DateInvalid: "Please enter a valid date",
  Q58DateBeforeIndex:
    "Date should be on or after the Bispecifics/CAR-T index date",
  Q58DateAfterPeriod:
    "Date should be on or before the end of the assessment period",
  Q58DateOutsideWindow:
    "Date is outside the allowed window around the target date for this row",
  Q58DateNotIncreasing:
    "Date should be on or after the date entered in the previous row",
  Q58WeightEmpty: "Please enter the weight or select “Unknown”",
  Q58WeightKgRange:
    "Allowed range: >= 1 and <= 630 kg only; up to two decimal places",
  Q58WeightLbsRange:
    "Allowed range: >= 1 and <= 1400 lbs only; up to two decimal places",
  ResolutionDtEmpty: "Please enter the date of resolution",
  chronologicalOrder:
    "Please ensure all dates are entered in the correct chronological order",
  OnsetDtEmpty:
    "Please enter the date of onset; this should be on or after the initiation date for this treatment and on or before the end of this line of treatment (plus 30 days), date of death (if applicable), or date of last patient encounter.",
  OnsetDtBeforeIndex:
    "Date should be on or after the initiation date for this treatment",
  DateBeforeIndex:
    "Date should be on or after the initiation date for this treatment",
  DtAfterAEEnd: "Date should be on or before the AE end date",
  EarlyImpDtEmpty: "Please enter the date of earliest improvement",
  //55
  // NeutroOnsetAfterResolution: "Date should be on or before the date of resolution of this neutropenia event",
  NeutroResolutionBeforeOnset:
    "Date should be on or after the onset for this neutropenia event",
  // NeutroOnsetBefore: "Date should be on or after both the initiation date for this treatment and onset for this neutropenia event and on or before the end of this line of treatment (plus 30 days), date of death (if applicable), or date of last patient encounter",
  // NeutroOnsetAfter: "Date should should be on or before the date of resolution of this neutropenia event, end of this line of treatment (plus 30 days), date of death (if applicable), or date of last patient encounter",

  //56
  // CytoOnsetAfterResolution: "Date should be on or before the date of resolution of this cytopenia event",
  CytoResolutionBeforeOnset:
    "Date should be on or after the onset for this cytopenia event",
  //59
  DysResBeforeEarlyImp:
    "Date should be on or after the date of earliest improvement of this dysgeusia event",
  //used for early imp n res- cols C, D
  DysResolutionBeforeOnset:
    "Date should be on or after the date of onset for this dysgeusia event",
  //60
  NailResBeforeEarlyImp:
    "Date should be on or after the date of earliest improvement of this nail disorder event",
  //used for early imp n res- cols C, D
  NailResolutionBeforeOnset:
    "Date should be on or after the date of onset for this nail disorder event",
  //61
  // SkinResBeforeOnset: "Date should be on or after the date of first occurrence of this skin disorder event",
  //used for early imp n res- cols C, D
  SkinResolutionBeforeOnset:
    "Date should be on or after the date of onset for this skin disorder event",
  SkinResBeforeEarlyImp:
    "Date should be on or after the date of earliest improvement of this skin disorder event",
  //63
  // NeuroOnsetAfterResolution: "Date should be on or before the date of resolution for this neurotoxicity event",
  NeuroResolutionBeforeOnset:
    "Date should be on or after the onset for this neurotoxicity event",

  //55
  NeutroOnsetDtEmpty:
    "Please enter the Date of neutropenia onset (if known) or “Unknown” otherwise",
  NeutroResDtEmpty:
    "Please enter the Date of neutropenia resolution (if known) or “Unknown” otherwise",
  //56
  CytoOnsetDtEmpty:
    "Please enter the Date of cytopenia onset (if known) or “Unknown” otherwise",
  CytoResDtEmpty:
    "Please enter the Date of cytopenia resolution (if known) or “Unknown” otherwise",
  //59, 60
  DysOnsetDtEmpty:
    "Please enter the Date of first occurrence (if known) or “Unknown” otherwise",
  DysEarlyDtEmpty:
    "Please enter the Earliest date of improvement (if known) or “Unknown” otherwise",
  DysResDtEmpty:
    "Please enter the Date of resolution (if known) or “Unknown” otherwise",
  //63
  NeuroOnsetDtEmpty:
    "Please enter the Date of neurotoxicity onset (if known) or “Unknown” otherwise",
  NeuroResDtEmpty:
    "Please enter the Date of neurotoxicity resolution (if known) or “Unknown” otherwise",
  //57, 63, 59
  ChkBoxRadNoSelection:
    "Please choose at least one of the provided options or “Unknown”",
  CheckedNoText: "Please enter the Infection organism",
  q57CheckedNoText: "Please specify the management care setting of AE",

  //59
  q59CheckedNoText: "Please describe the intervention received",

  //Date of Onset
  DtSameAsPrevEpisodes:
    "Date of onset should not be the same as the previous episodes",

  //58
  WtLossResolutionBeforeOnset:
    "Date should be on or after the date of onset for this weight loss event",
  WtLossBeforeResolution:
    "Date should be on or after the date of resolution for this weight loss event",
  WtLossStabilizationDtEmpty: "Please enter the date of weight becoming stable",
  Q53q36CRS:
    "WARNING: you have indicated that the patient had at least 1 step-up dosing hospitalization to manage CRS in Q36.1 yet no events are reported here. Please revise accordingly.",
  // QAQC-044 - the Q39.1.C / Q39.2.C references only apply to centers with
  // Element C enabled, since those sub-questions don't exist otherwise.
  Q53q39CRS: (isNewEcrfC) =>
    `WARNING: you have indicated that the patient used tocilizumab and/or steroids to manage CRS in Q39.1.A${isNewEcrfC ? ", Q39.1.C" : ""}, Q39.2${isNewEcrfC ? ", Q39.2.C" : ""}, or Q43.1.A, yet no events are reported here. Please revise accordingly.`,
  Q63q39Neurotoxicity:
    "WARNING: you have indicated that the patient used tocilizumab and/or steroids to manage neurologic events in Q39.1.A, Q39.1.C, Q39.2, Q39.2.C, or Q43.1.A (whichever applicable for Update A vs. C), yet no events are reported here. Please revise accordingly.",
  // QAQC-045 Rule B - subtype name is inserted dynamically at render time
  Q63q432ASubtypeWarning: (subtypeName) =>
    `WARNING: you have indicated that the patient experienced a reason for IV corticosteroid usage during the cohort-defining treatment LOT due to ${subtypeName}, yet no neurologic event AE is reported with the same subtype. Please revise to ensure at least 1 row per subtype is listed here and questions match accordingly.`,
  // QAQC-045 Rule C - subtype name is inserted dynamically at render time
  Q63q26SubtypeWarning: (subtypeName) =>
    `WARNING: you have indicated that the patient discontinued the cohort-defining line of treatment due to specific neurologic event subtype ${subtypeName}, yet no neurologic event AE is reported with the same subtype. Please revise to ensure at least 1 row per subtype is listed here and questions match accordingly.`,
  // QAQC-045 Rule D - subtype name is inserted dynamically at render time
  Q63q38SubtypeWarning: (subtypeName) =>
    `WARNING: you have indicated that the patient experienced a dose frequency change, dose strength change, or dose interruption/delay during the cohort-defining treatment LOT due to a specific neurologic event subtype ${subtypeName}, yet no neurologic event AE is reported with the same subtype. Please revise to ensure at least 1 row per subtype is listed here and questions match accordingly.`,
  Q54q36ICANS:
    "WARNING: you have indicated that the patient had at least 1 step-up dosing hospitalization to manage ICANS in Q36.1 yet no events are reported here. Please revise accordingly.",

  // QAQC-040 - AE-vs-discontinuation-reason (Q26/Q26.1) consistency
  CrsQ26WarningMessage:
    "WARNING: you have indicated that the patient discontinued the cohort-defining line of treatment due to CRS, yet no events are reported here. Please revise accordingly.",
  IcansQ26WarningMessage:
    "WARNING: you have indicated that the patient discontinued the cohort-defining line of treatment due to ICANS, yet no events are reported here. Please revise accordingly.",
  NeutQ26WarningMessage:
    "WARNING: you have indicated that the patient discontinued the cohort-defining line of treatment due to neutropenia, yet no events are reported here. Please revise accordingly.",
  CytoQ26WarningMessage:
    "WARNING: you have indicated that the patient discontinued the cohort-defining line of treatment due to cytopenia, yet no events are reported here. Please revise accordingly.",
  InfQ26WarningMessage:
    "WARNING: you have indicated that the patient discontinued the cohort-defining line of treatment due to infection, yet no events are reported here. Please revise accordingly.",
  DysQ26WarningMessage:
    "WARNING: you have indicated that the patient discontinued the cohort-defining line of treatment due to dysgeusia, yet no events are reported here. Please revise accordingly.",
  NailQ26WarningMessage:
    "WARNING: you have indicated that the patient discontinued the cohort-defining line of treatment due to a nail-related disorder, yet no events are reported here. Please revise accordingly.",
  SkinQ26WarningMessage:
    "WARNING: you have indicated that the patient discontinued the cohort-defining line of treatment due to a skin-related disorder, yet no events are reported here. Please revise accordingly.",
  SpmQ26WarningMessage:
    "WARNING: you have indicated that the patient discontinued the cohort-defining line of treatment due to a secondary primary malignancy, yet no events are reported here. Please revise accordingly.",
  NeurotoxQ26WarningMessage:
    "WARNING: you have indicated that the patient discontinued the cohort-defining line of treatment due to a neurologic event, yet no events are reported here. Please revise accordingly.",
  EntQ26WarningMessage:
    "WARNING: you have indicated that the patient discontinued the cohort-defining line of treatment due to enterocolitis, yet no events are reported here. Please revise accordingly.",

  // QAQC-041 - AE-vs-dose-change (Q38.1.A/Q38.2.A) consistency
  CrsQ38WarningMessage:
    "WARNING: you have indicated that the patient experienced a dose frequency change, dose strength change, or dose interruption/delay during the cohort-defining treatment LOT due to CRS, yet no events are reported here. Please revise accordingly.",
  IcansQ38WarningMessage:
    "WARNING: you have indicated that the patient experienced a dose frequency change, dose strength change, or dose interruption/delay during the cohort-defining treatment LOT due to ICANS, yet no events are reported here. Please revise accordingly.",
  NeutQ38WarningMessage:
    "WARNING: you have indicated that the patient experienced a dose frequency change, dose strength change, or dose interruption/delay during the cohort-defining treatment LOT due to neutropenia, yet no events are reported here. Please revise accordingly.",
  CytoQ38WarningMessage:
    "WARNING: you have indicated that the patient experienced a dose frequency change, dose strength change, or dose interruption/delay during the cohort-defining treatment LOT due to cytopenia, yet no events are reported here. Please revise accordingly.",
  InfQ38WarningMessage:
    "WARNING: you have indicated that the patient experienced a dose frequency change, dose strength change, or dose interruption/delay during the cohort-defining treatment LOT due to infection, yet no events are reported here. Please revise accordingly.",
  DysQ38WarningMessage:
    "WARNING: you have indicated that the patient experienced a dose frequency change, dose strength change, or dose interruption/delay during the cohort-defining treatment LOT due to dysgeusia, yet no events are reported here. Please revise accordingly.",
  NailQ38WarningMessage:
    "WARNING: you have indicated that the patient experienced a dose frequency change, dose strength change, or dose interruption/delay during the cohort-defining treatment LOT due to a nail-related disorder, yet no events are reported here. Please revise accordingly.",
  SkinQ38WarningMessage:
    "WARNING: you have indicated that the patient experienced a dose frequency change, dose strength change, or dose interruption/delay during the cohort-defining treatment LOT due to a skin-related disorder, yet no events are reported here. Please revise accordingly.",
  SpmQ38WarningMessage:
    "WARNING: you have indicated that the patient experienced a dose frequency change, dose strength change, or dose interruption/delay during the cohort-defining treatment LOT due to a secondary primary malignancy, yet no events are reported here. Please revise accordingly.",
  NeurotoxQ38WarningMessage:
    "WARNING: you have indicated that the patient experienced a dose frequency change, dose strength change, or dose interruption/delay during the cohort-defining treatment LOT due to a neurologic event, yet no events are reported here. Please revise accordingly.",
  EntQ38WarningMessage:
    "WARNING: you have indicated that the patient experienced a dose frequency change, dose strength change, or dose interruption/delay during the cohort-defining treatment LOT due to enterocolitis, yet no events are reported here. Please revise accordingly.",

  // QAQC-042 - AE-vs-AE-management (Q43.2.A CAR-T corticosteroid) consistency
  CrsQ43WarningMessage:
    "WARNING: you have indicated that the patient used IV corticosteroids during the CAR-T LOT due to CRS, yet no events are reported here. Please revise accordingly.",
  IcansQ43WarningMessage:
    "WARNING: you have indicated that the patient used IV corticosteroids during the CAR-T LOT due to ICANS, yet no events are reported here. Please revise accordingly.",
  NeutQ43WarningMessage:
    "WARNING: you have indicated that the patient used IV corticosteroids during the CAR-T LOT due to neutropenia, yet no events are reported here. Please revise accordingly.",
  CytoQ43WarningMessage:
    "WARNING: you have indicated that the patient used IV corticosteroids during the CAR-T LOT due to cytopenia, yet no events are reported here. Please revise accordingly.",
  SpmQ43WarningMessage:
    "WARNING: you have indicated that the patient used IV corticosteroids during the CAR-T LOT due to secondary primary malignancy (other than MM), yet no events are reported here. Please revise accordingly.",
  NeurotoxQ43WarningMessage:
    "WARNING: you have indicated that the patient used IV corticosteroids during the CAR-T LOT due to a neurologic event, yet no events are reported here. Please revise accordingly.",
  EntQ43WarningMessage:
    "WARNING: you have indicated that the patient used IV corticosteroids during the CAR-T LOT due to enterocolitis, yet no events are reported here. Please revise accordingly.",

  AEMessages:
    "WARNING: you have indicated that the patient had an AE-related hospitalization during step-up dosing or discontinued the cohort-defining treatment LOT due to an adverse event yet no AEs are reported here. Please revise accordingly, unless the AE is not one of those requested in this section.",
  //64
  EnterocolitiesDateAfterEarlyImp:
    "Date should be on or after the date of earliest improvement of this enterocolitis event",
  EntOnsetAfterResolution:
    "Date should be on or before the date of resolution for this enterocolitis event",
  EntOnsetAfterAEEndDate:
    "Date should be on or before the AE end date for this enterocolitis event",
  EntResolutionBeforeOnset:
    "Date should be on or after the onset for this enterocolitis event",
  EntImpDateAfterOnsetAndIndex:
    "Date should be on or after both the initiation date for this treatment and onset date for this enterocolitis event",
  EntResDateAfterOnsetIndexImp:
    "Date should be on or after the initiation date for this treatment and on or after onset date and on or after earliest improvement date for this enterocolitis event",
  SPMResolutionBeforeOnset:
    "Date should be on or after the onset for this Secondary primary malignancy event",

  //65
  LymOnsetAfterAEEndDate:
    "Date should be on or before the AE end date for this lymphopenia event",
  LymResDateAfterOnsetIndexImp:
    "Date should be on or after the initiation date for this treatment and on or after onset date for this lymphopenia event",
  LymQ26WarningMessage:
    "WARNING: you have indicated that the patient discontinued the cohort-defining line of treatment due to lymphopenia, yet no events are reported here. Please revise accordingly.",
  LymQ381AWarningMessage:
    "WARNING: you have indicated that the patient experienced a dose frequency change, dose strength change, or dose interruption/delay during the cohort-defining treatment LOT due to lymphopenia, yet no events are reported here. Please revise accordingly.",
  LymQ432AWarningMessage:
    "WARNING: you have indicated that the patient used IV corticosteroids during the CAR-T LOT due to lymphopenia, yet no events are reported here. Please revise accordingly.",

  //66
  DizOnsetDtEmpty: "Please enter the date of onset",
  DizOnsetOutOfRange:
    "The date of onset should be on or after the index date for this treatment and on or before the Resolution date and AE end date for this dizziness event",
  DizResolutionBeforeOnset:
    "The date of resolution should be on or after the date of onset and before the AE end date for this dizziness event",
  DizQ26WarningMessage:
    "WARNING: you have indicated that the patient discontinued the cohort-defining line of treatment due to dizziness, yet no events are reported here. Please revise accordingly.",
  DizQ381AWarningMessage:
    "WARNING: you have indicated that the patient experienced a dose frequency change, dose strength change, or dose interruption/delay during the cohort-defining treatment LOT due to dizziness, yet no events are reported here. Please revise accordingly.",

  //67
  AtxOnsetDtEmpty: "Please enter the date of onset",
  AtxOnsetOutOfRange:
    "The date of onset should be on or after the index date for this treatment and on or before the Resolution date and AE end date for this ataxia event",
  AtxResolutionBeforeOnset:
    "The date of resolution should be on or after the date of onset and before the AE end date for this ataxia event",
  AtxQ26WarningMessage:
    "WARNING: you have indicated that the patient discontinued the cohort-defining line of treatment due to ataxia, yet no events are reported here. Please revise accordingly.",
  AtxQ381AWarningMessage:
    "WARNING: you have indicated that the patient experienced a dose frequency change, dose strength change, or dose interruption/delay during the cohort-defining treatment LOT due to ataxia, yet no events are reported here. Please revise accordingly.",
  AtxPresentationOtherTxtEmpty: "Please describe the presentation of ataxia",
  AtxFDiscontinuationMismatch:
    "WARNING: you have indicated that interventions for managing ataxia included Tal dose discontinuation. However, responses here do not match responses in Q26. Please review and revise accordingly.",
  AtxFDoseReductionMismatch:
    "WARNING: you have indicated that interventions for managing ataxia included Tal dose strength/frequency reduction. However, responses here do not match responses in Q38.1.A. Please review and revise accordingly",
  AtxFInterruptionMismatch:
    "WARNING: you have indicated that interventions for managing ataxia included Tal dose interruption/delay. However, responses here do not match responses in Q38.2.A. Please review and revise accordingly",

  //Q57.1.B
  ImmonoglobinAssessmentDateEmpty: "Please enter the date of IgG assessment",
  AssessmentDtSameAsPrevEpisodes:
    "Date of IgG assessment should not be the same as the previous episodes",
  ImmonoglobinAssessmentDtAfterEndDateError:
    "Date should be on or before the start date of subsequent LOT, AE end date, or end of follow-up for this immunoglobin event",
  ImmonoglobinUnitError: "Please enter the dosage",
  ImmonoglobinUnitInvalidError: "Please enter the dosage",
  ImmonoglobiC1Range:
    "Please enter a value between 0.01 and 5000 (up to 2 decimals permitted)",
  ImmonoglobinC2Range:
    "Please enter a value between 0.01 and 50  (up to 2 decimals permitted)",
  ImmunoglobinWarningMessage:
    "WARNING: for at least 1 row, you have reported a date of IgG level assessment prior to the onset date of the AE infection episode that the IgG assessment is associated with. Please ensure that this IgG level should be attributed to this AE episode or revise accordingly, as needed.",

  //Q57 - Date of most recent IgG assessment prior to infection / IgG level (Element C)
  IggAssessmentDateEmpty:
    "Please enter the date of most recent IgG assessment prior to infection",
  IggLevelUnitEmpty: "Please enter the IgG level",
  IggLevelC1Range: "Please enter a whole number value between 1 and 5000",
  IggLevelC2Range: "Please enter a whole number value between 1 and 50",
  IggAssessmentDateBeforeDiagnosisError:
    "Date should be on or after the date of initial MM diagnosis",
  IggAssessmentDateAfterOnsetError:
    "Date should be on or before the date of onset for this infection episode",
  OnsetDtBeforeDiagnosis:
    "Date should be on or after the date of initial MM diagnosis",
};

export const TreatmentResponseProgression_Msgs = {
  RadioEmtypError: "Please choose one of the provided options.",
  Q44DateEmpty: "Please enter the date of progression assessment",
  Q44DateOutOfBoundError:
    "Date of progression assessment must be on or after NDMM index date or the earliest of RRMM index date and on or before the start date of next LOT + 45 days (if applicable) or end of follow-up.",
  Q44DateDuplicateAcrossCohortsError:
    "The date of disease progression reported in Q44 must be unique for each cohort-defining treatment and should not be the same across different NDMM or RRMM lines of treatment. Please review and correct the reported dates as needed.",

  Q44Reason: "Please choose at least one of the provided options or “Unknown” ",
  MethodOfAssessmentCEmpty:
    "Please choose at least one of the provided options or “Unknown” ",
  MethodOfAssessmentCTxtEmpty: "Please specify the method of assessment.",
  Q44WarningDiseaseProgression:
    "WARNING: you have indicated that the patient discontinued the cohort-defining treatment LOT due to disease progression in Q22-Q26 yet report no PD here. Please revise accordingly.",
  ProgressionReasonTextEmpty: "Please specify the reason of progression.",

  Q45DateEmpty: "Please enter the date of response assessment",
  Q45WarningAchievedCR:
    "WARNING: you have indicated that the patient discontinued the cohort-defining treatment LOT due to achieving CR or better in Q22-Q26 yet report no CR or sCR here. Please revise accordingly.",
  Q45WarningAchievedVGPR:
    "WARNING: you have indicated that the patient discontinued the cohort-defining treatment LOT due to achieving VGPR or better in Q22-Q26 yet report no VGPR, CR or sCR here. Please revise accordingly.",
  Q45WarningAchievedSuboptimalResponse:
    "WARNING: you have indicated that the patient discontinued the cohort-defining treatment LOT due to a suboptimal response of PR or SD in Q22-Q26 yet report no PR or SD here. Please revise accordingly.",
  Q45DateMismatch:
    "The date of First Positive Response must be the same as the date of Best Response when the First Positive Response and Best Response statuses are the same. Please review and revise the response date as needed.",
  Q45DateMismatchBR:
    "The date of Best Response must be the same as the date of First Positive Response when the First Positive Response and Best Response statuses are the same. Please review and revise the response date as needed.",
  Q45PDDateMismatch:
    "When Best Response is “Progressive disease (PD),” the date of Best Response must be the same as the date of disease progression reported in Q44. Please review and revise the date(s) as needed.",
  Q45StatusMismatchSameDate:
    "If the date of First positive response and Best response are the same, the response statuses must match.",
  Q45StatusRelationshipInvalid:
    "The selected First Positive Response and Best Response statuses are inconsistent. Please review and revise the response statuses so that Best Response is consistent with the selected First Positive Response.",
  Q45PDQ44NotOccurredError:
    "When Best Response is “Progressive disease (PD),” “Disease progression did not occur” cannot be selected in Q44. Please review and revise the Best Response or Q44 response as needed.",
  Q45DateOutOfBoundError:
    "Date of response assessment must be on or after NDMM index date or the earliest of RRMM index date and on or before the start date of next LOT + 45 days (if applicable) or end of follow-up.",
  Q45FRDateDuplicateAcrossCohortsError:
    "The date of first response reported in Q45 must be unique for each cohort-defining treatment and should not be the same across different NDMM or RRMM lines of treatment. Please review and correct the reported dates as needed.",
  Q45BRDateDuplicateAcrossCohortsError:
    "The date of best response reported in Q45 must be unique for each cohort-defining treatment and should not be the same across different NDMM or RRMM lines of treatment. Please review and correct the reported dates as needed.",

  Q46DateEmpty: "Please enter the date of MRD assessment.",
  Q46DateOutOfBoundError:
    "Date of MRD assessment must be on or after NDMM index date or the earliest of RRMM index date and on or before the start date of next LOT + 45 days (if applicable) or end of follow-up.",
  Q46DateDuplicateAcrossCohortsError:
    "The date of MRD assessment reported in Q46 must be unique for each cohort-defining treatment and should not be the same across different NDMM or RRMM lines of treatment. Please review and correct the reported dates as needed.",

  Q46Sensitivity: "Please choose one of the provided options.",
  Q46MRDStatus: "Please choose one of the provided options.",
  Q46Achievednegativity105:
    "WARNING: you have indicated that the patient discontinued the cohort-defining treatment LOT due to achieving MRD negativity status at 10-5 sensitivity yet do not report that here. Please revise accordingly.",
  Q46Achievednegativity106:
    "WARNING: you have indicated that the patient discontinued the cohort-defining treatment LOT due to achieving MRD negativity status at 10-6 sensitivity yet do not report that here. Please revise accordingly.",

  Q47DateEmpty: "Please enter the date of progression assessment.",
  Q47Reason: "Please choose at least one of the provided options or “Unknown” ",
  Q47NDMMDateOutOfBoundError:
    "Date of progression assessment must be on or after the NDMM 2L LOT start date and on or before the start date of next LOT + 45 days (if applicable) or end of follow-up.",
  Q47Q44DateMismatch:
    "Date of disease progression here must be different from the date of disease progression reported in Q44.",

  Q47WarningMsg:
    "WARNING: you have indicated that the patient discontinued the 2nd LOT due to disease progression in Q28 yet report no PD here. Please revise accordingly.",
  //Q47 rule 4 - Q28 reports insufficient response without progression, yet a
  //progression is reported here.
  Q47InsufficientResponseWarning:
    "WARNING: you have indicated that the patient had disease progression yet report that the reason for discontinuing in Q28 was insufficient response without progression. Please revise accordingly.",
  //Q47 rule 5 - assessment date falls after the next LOT start (warning only).
  Q47AfterNextLotWarning:
    "WARNING: you have reported an assessment falls after the start of the next line of therapy. Please ensure that this assessment corresponds to the cohort-defining treatment line of therapy or revise accordingly.",

  Q48DateEmpty: "Please enter the date of response assessment.",
  Q48WarningInsufficientResponse:
    "WARNING: you have indicated that the discontinued treatment on 2L due to an insufficient response in Q28 yet report no such insufficient response here. Please revise accordingly.",
  Q48PDDateMismatch:
    "When Best Response is “Progressive disease (PD),” the date of Best Response must be the same as the date of disease progression reported in Q47. Please review and revise the date(s) as needed.",
  Q48DateMismatch:
    "The date of First Positive Response must be the same as the date of Best Response when the First Positive Response and Best Response statuses are the same. Please review and revise the response date as needed.",
  Q48DateMismatchBR:
    "The date of Best Response must be the same as the date of First Positive Response when the First Positive Response and Best Response statuses are the same. Please review and revise the response date as needed.",
  Q48StatusMismatchSameDate:
    "If the date of First positive response and Best response are the same, the response statuses must match.",
  Q48StatusRelationshipInvalid:
    "The selected First Positive Response and Best Response statuses are inconsistent. Please review and revise the response statuses so that Best Response is consistent with the selected First Positive Response.",
  Q48PDQ47NotOccurredError:
    "When Best Response is “Progressive disease (PD),” “Disease progression did not occur” cannot be selected in Q47. Please review and revise the Best Response or Q47 response as needed.",
  Q48NDMMDateOutOfBoundError:
    "Date of progression assessment must be on or after the NDMM 2nd LOT start date and on or before the start date of next LOT + 45 days (if applicable) or end of follow-up.",

  Q49DateEmpty: "Please enter the date of progression assessment.",
  Q49Reason: "Please choose at least one of the provided options or “Unknown”",
  Q49WarningDiseaseProgression:
    "WARNING: you have indicated that the patient discontinued treatment on 3L due to disease progression in Q30 yet report no PD here. Please revise accordingly.",
  Q49NDMMDateOutOfBoundError:
    "Date of progression assessment must be on or after the NDMM 3rd LOT start date and on or before the start date of next LOT + 45 days (if applicable) or end of follow-up.",
  Q49Q44Q47DateMismatch:
    "Date of disease progression here must be different from the date of disease progression reported in Q44 or Q47.",

  Q50DateEmpty: "Please enter the date of response assessment.",
  Q50NDMMDateOutOfBoundError:
    "Date of response assessment must be on or after the NDMM 3rd LOT start date and on or before the start date of next LOT + 45 days (if applicable) or end of follow-up.",

  Q50DateMismatch:
    "The date of First Positive Response must be the same as the date of Best Response when the First Positive Response and Best Response statuses are the same. Please review and revise the response date as needed.",
  Q50DateMismatchBR:
    "The date of Best Response must be the same as the date of First Positive Response when the First Positive Response and Best Response statuses are the same. Please review and revise the response date as needed.",
  Q50PDDateMismatch:
    "When Best Response is “Progressive disease (PD),” the date of Best Response must be the same as the date of disease progression reported in Q49. Please review and revise the date(s) as needed.",
  Q50StatusMismatchSameDate:
    "If the date of First positive response and Best response are the same, the response statuses must match.",
  Q50StatusRelationshipInvalid:
    "The selected First Positive Response and Best Response statuses are inconsistent. Please review and revise the response statuses so that Best Response is consistent with the selected First Positive Response.",
  Q50PDQ49NotOccurredError:
    "When Best Response is “Progressive disease (PD),” “Disease progression did not occur” cannot be selected in Q49. Please review and revise the Best Response or Q49 response as needed.",
  Q50WarningInsufficientResponse:
    "WARNING: you have indicated that the patient discontinued treatment on 3L due to an insufficient response in Q30 yet report no such insufficient response here. Please revise accordingly.",

  Q51DateEmpty: "Please enter the date of progression assessment.",
  Q51Reason: "Please choose at least one of the provided options or “Unknown”",
  Q51WarningDiseaseProgression:
    "WARNING: you have indicated that the patient discontinued treatment on the subsequent LOT due to disease progression in Q33 yet report no PD here. Please revise accordingly.",
  Q51DateOutOfBoundError:
    "Date of progression assessment must be on or after the start of RRMM LOT + 1 in Q31 and on or before the start date of next LOT + 45 days (if applicable) or end of follow-up.",

  Q52Treatment: "Please choose one of the provided options",
  Q52DateEmpty: "Please enter the date of response assessment.",
  Q52DateMismatch:
    "If the same response option is selected in “First positive response” as “Best response”, please ensure the dates match.",
  Q52PDDateMismatch:
    "If Best Response is “Progressive disease (PD)”, please ensure that the date of best response matches the date of disease progression in Q51.",
  Q52DateOutOfBoundError:
    "Date of response assessment must be on or after the start of RRMM LOT + 1 in Q31 and on or before the start date of next LOT + 45 days (if applicable) or end of follow-up.",

  Q52WarningInsufficientResponse:
    "WARNING: you have indicated that the patient discontinued treatment on the subsequent LOT due to an insufficient response in Q33 yet report no such insufficient response here. Please revise accordingly.",
};

export const ELCharacteristics_MSGS = {
  // General validation messages
  DecimalRange:
    "Please enter a value between 0.00 and 4000 (up to 2 decimals permitted)",
  General: "Please choose one of the provided options",

  // Steroid-related messages
  name_dose_steroidslinvoHardEmpty:
    "Please choose at least one of the provided options or Unknown ",
  name_dose_steroidsHardEmpty:
    "Please choose at least one of the provided options or Unknown ",
  steroids_linvo_txtEmpty: "Please describe the total dose strength",
  steroids_elr_txtEmpty: "Please describe the total dose strength",

  // Common administration messages
  doseFrequencyEmpty: "Please choose one of the provided options",
  doseFrequencyValueEmpty: "Please choose one of the provided options",
  administrationEmpty: "Please choose one of the provided options",
  dosingphaseEmpty: "Please choose one of the provided options",
  siteofcareEmpty: "Please choose one of the provided options",
  admissionEmpty: "Please choose one of the provided options",
  dischargeEmpty: "Please choose one of the provided options",
  administrationEmptyDate:
    "Please enter the date of dose administration (if known) or unknown ",
  admissionEmptyDate:
    "Please enter the date of admission (if known) or unknown ",
  dischargeEmptyDate:
    "Please enter the date of discharge (if known) or Unknown ",
  admissionDateCheck:
    "Please select date of admission which is not less than date of discharge",
  dischargeDateCheck:
    "Please Select date of discharge which is greater than date of admission",

  // ELREXFIO-specific messages
  indexDateRRMMNotMatchingElr:
    "Please Select at least 1 date of dose administration(Elrexfio) = Bispecific/CAR-T initiation date ",
  RRMMNotMatchingElr:
    "The number of dose administrations (rows) listed in Q36(Elrexfio) does not match what is expected based on your response in Q26 Number of administrations. Please check and ensure that these match.",

  DoseMustMatchLastAdministrationDateElr:
    "Please select at least 1 date of dose administration (Elrexfio) = date of last administration in Q26 (Elrexfio)",

  // LINVOSELTAMAB-specific messages
  indexDateRRMMNotMatchingLinvo:
    "Please Select at least 1 date of dose administration(Linvoseltamab) = Bispecific/CAR-T initiation date ",
  RRMMNotMatchingLinvo:
    "The number of dose administrations (rows) listed in Q36(Linvoseltamab) does not match what is expected based on your response in Q26 Number of administrations. Please check and ensure that these match.",

  DoseMustMatchLastAdministrationDateLinvo:
    "Please select at least 1 date of dose administration (Linvoseltamab) = date of last administration in Q26 (Linvoseltamab)",

  // Q39 - Elrexfio messages
  Q39elrSteroidsEmptyHard:
    "Please choose at least one of the provided options or Unknown",
  Q39ElrEmptyHard: "Please choose one of the provided options",
  Q39elrReasonHard:
    "Please choose at least one of the provided options or Unknown",
  Q39elrGranduloEmptyHard:
    "Please choose at least one of the provided options or Unknown",

  // Q39 - Linvoseltamab messages
  Q39LinvoEmptyHard: "Please choose one of the provided options",
  Q39linvoReasonHard: "Please choose at least one of the provided options",
  Q39linvoSteroidsEmptyHard:
    "Please choose at least one of the provided options or Unknown",
  Q39linvoGranduloEmptyHard:
    "Please choose at least one of the provided options or Unknown",

  // Q39.C - Elrexfio / Linvoseltamab messages (eCRF New Elements C)
  Q39CEmptyHard: "Please choose one of the provided options",
  Q391CReasonEmptyHard:
    "Please choose at least one of the provided options or Unknown",
  Q391CDateEmpty: "Please enter the administration date or choose Unknown",
  Q391CDateInvalid: "Please enter a valid date",
  Q391CDoseEmptyHard: "Please provide dose information or choose Unknown",
  Q391CDoseOtherEmptyHard: "Please specify the dose",
  Q391CDoseRangeInvalid:
    "Please enter a value greater than 0 and less than or equal to 15",

  // Q39.2.C - Elrexfio / Linvoseltamab messages (eCRF New Elements C)
  Q392CDoseEmptyHard:
    "Please select at least one steroid and provide its dose per day, or choose Unknown",
  Q392CDoseTxtEmptyHard:
    "Please provide the dose per day for the selected steroid(s)",
  Q392CDoseRangeInvalid: "Please enter a value greater than or equal to 0",
  Q392CReasonEmptyHard:
    "Please choose at least one of the provided options or Unknown",

  // Q39.3.C - Elrexfio / Linvoseltamab messages (eCRF New Elements C)
  Q393CReasonEmptyHard:
    "Please choose at least one of the provided options or Unknown",

  // Q38 - Elrexfio messages
  Q38ElrEmptyHard: "Please choose one of the provided options",
  Q38DateEmpty:
    "Please enter the date of dose frequency reduction (if known) or unknown otherwise",
  Q38ElrDateInvalid:
    "At least one of the dates of dose frequency reduction is invalid. Please ensure that all dates of dose frequency reduction are after the treatment initiation date and on or before the date of last dose administration for the treatment cohort.",

  // Q38 - Linvoseltamab messages
  Q38LinvoEmptyHard: "Please choose one of the provided options",
  Q38LinvoDateEmpty:
    "Please enter the date of dose frequency reduction (if known) or unknown otherwise",
  Q38LinvoDateInvalid:
    "At least one of the dates of dose frequency reduction is invalid. Please ensure that all dates of dose frequency reduction are after the treatment initiation date and on or before the date of last dose administration for the treatment cohort.",

  specifyOtherText: "Please specify other text",
  specifyDosageFrequency: "Please describe the dosing strength",
  allowedRange: "Please enter a value between 0 and 50",

  // Linvoseltamab administration messages
  administrationEmpty_linvo: "Please choose one of the provided options",
  dosingphaseEmpty_linvo: "Please choose one of the provided options",
  siteofcareEmpty_linvo: "Please choose one of the provided options",
  admissionEmpty_linvo: "Please choose one of the provided options",
  dischargeEmpty_linvo: "Please choose one of the provided options",

  // Elrexfio administration messages
  administrationEmpty_elr: "Please choose one of the provided options",
  dosingphaseEmpty_elr: "Please choose one of the provided options",
  siteofcareEmpty_elr: "Please choose one of the provided options",
  admissionEmpty_elr: "Please choose one of the provided options",
  dischargeEmpty_elr: "Please choose one of the provided options",

  // Q37 messages
  q37LinvoseltamabEmpty: "Please choose one of the provided options",
  q37ElrexfioEmpty: "Please choose one of the provided options",

  // Q40 - IVIG messages
  Q40DosingFreqEmptyHard: "Please choose one of the provided options",
  Q40DosingFreqTxtEmptyHard: "please enter the dosing frequency",
  Q40IgGEmptyHard: "Please choose one of the provided options",
  Q40Init_dtHard:
    "Please enter the initiation date of IVIG (if known) or unknown otherwise",
  Q40Init_RdHard: "Please choose one of the provided options",
  Q40ReasonEmptyHard: "Please choose at least one of the provided options",

  //40.C
  ivigInitRdHardC: "Please choose one of the provided options",
  ivigInitDtHardC: "Please enter the initiation date of IVIG",
  ivigInitDtInvalidC: "Please enter a valid date",
  ivigInitDtBeforeEofC:
    "Date should be between Bispecific/CAR-T initiation date and end of follow up",
  ivigInitDtFullChainOutOfRangeC:
    "Please ensure that the Bispecific/CAR-T Index Date is on or before the Bispecific/CAR-T Initiation Date, which is on or before the Date in Column [B], the Date of Last Administration reported in Column [D] of Q26 (if known), the End Date of LOT in Q26.2, the Start Date of Subsequent LOT (if reported), and the End of Follow-up.",
  ivigDosingTypeEmptyHardC: "Please choose one of the provided options",
  ivigDosingFreqEmptyHardC: "Please choose one of the provided options",
  ivigDosingFreqTxtEmptyHardC: "Please enter the dosing frequency",
  ivigDosingFreqRangeInvalidC: "Allowed range: > 0 and ≤ 10; integers only",
  ivigReasonEmptyHardC: "Please choose at least one of the provided options",
  ivigReasonOtherTxtEmptyHardC: "Please specify the other reason",
  ivigDoseStrengthEmptyHardC: "Please provide the initial dose strength",
  ivigDoseStrengthRangeInvalidC: "Allowed range: > 0 and < 200",
  ivigDoseStrengthMgKgRangeInvalidC: "Allowed range: > 0 and < 2000",
  ivigDoseStrengthOtherTxtEmptyHardC: "Please specify the dose strength",
  ivigBodyWeightEmptyHardC: "Please choose one of the provided options",
  ivigBodyWeightKgRangeInvalidC:
    "Allowed range: ≥ 1 and ≤ 630; up to two decimal places",
  ivigBodyWeightLbsRangeInvalidC:
    "Allowed range: ≥ 1 and ≤ 1400; up to two decimal places",
  ivigLastIggEmptyHardC: "Please choose one of the provided options",

  //40.1.C
  Q401cChangeTypeEmptyHard: "Please choose one of the provided options",
  Q401cFreqBeforeEmptyHard: "Please provide dose frequency before change",
  Q401cFreqBeforeTxtEmptyHard: "Please enter the dosing frequency",
  Q401cFreqBeforeRangeInvalid: "Allowed range: > 0 and ≤ 10; integers only",
  Q401cFreqAfterEmptyHard: "Please provide dose frequency after change",
  Q401cFreqAfterTxtEmptyHard: "Please enter the dosing frequency",
  Q401cFreqAfterRangeInvalid: "Allowed range: > 0 and ≤ 10; integers only",
  Q401cDateChangeRdHard: "Please choose one of the provided options",
  Q401cDateChangeDtHard:
    "Please enter the date of dose frequency change (if known) or unknown otherwise",
  Q401cDateChangeInvalid: "Please enter a valid date",
  Q401cDateChangeOutOfBound:
    "The date must be on or after the IVIG initiation date (or Bispecific/CAR-T initiation date, if unknown) and on or before the start date of the next LOT (if applicable) or end of follow-up",
  Q401cFrequencyIncreaseConflict:
    "Dose frequency after change must be greater than before",
  Q401cFrequencyDecreaseConflict:
    "Dose frequency after change must be less than before",
  Q401cChainMismatchWarning:
    "WARNING: for at least one dose frequency change, the dose frequency after change does not match the dose frequency before the next chronological change. Please confirm the dose frequency values and dates entered are correct and revise accordingly, as needed.",

  // Q36.1 - Hospitalization messages
  Q36Point1ReasonTxtEmpty: "Please enter the hospitalization reason",
  Q361DateRangeError:
    "The date must be on or after the Bispecific/CAR-T initiation date - 2 days and on or before the 1st subsequent treatment dose in Q36, the last administration date in Q26 (if known), the end date of LOT in Q26.2, the start date of the subsequent LOT (if applicable), and the end of follow-up date.",

  // Q36 and Q36.1 - Date validation messages
  Q36DateOutOfBound: "Date should be between index date and end of follow up",
  // Q36.1 - hospitalization admission date
  Q361DateOutOfBound:
    "Date should be between Bispecific/CAR-T initiation date and end of follow up",
  dateRangeFourty:
    "Date of discharge – date of admission difference should be less than 40 days",
  DateRangeThirty:
    "WARNING: you have entered at least one hospitalization with a duration that exceeds 1 month in duration. Please confirm the start and end dates of all hospitalizations and revise accordingly, as needed.",
  DateBeforeEOF: "The date must be on or before the End of Follow-up date.",

  IdenticalWarning:
    "WARNING: you have entered duplicate dose administrations with the same step-up dosing phase (i.e., at least two rows where Step-up dose 1, Step-up dose 2 or 1st treatment dose have been recorded). The likelihood of this occurrence is considered rare and should occur only if multiple step-up doses occurred. If the patient did not experience multiple step-up doses, please revise accordingly.",
  StepUpWarning:
    "WARNING: you have entered 1st treatment dose but no other step-up dosing information. It is expected that patients should receive Step-up dose 1, Step-up dose 2, and (when applicable) Step-up dose 3. Please double-check and add any missing records for step-up dosing.",
  Q26Warning:
    "WARNING: Based on the number of administrations provided in Q26, it is expected that the patient received all step-up doses and the 1st subsequent treatment dose. Please double-check and add any missing records.",
  Dose2Warning:
    "Step-up Dose 2 cannot be reported as Patient did not receive dose when Step-up Dose 3 has been reported with a date or as Date unknown.",
  FirstTreatmentWarning:
    "Step-up Dose 2 or Step-up Dose 3 cannot be reported as Patient did not receive dose when the 1st Treatment Dose has been reported with a date or as Date unknown.",
  FirstSubsWarning:
    "Step-up Dose 2, Step-up Dose 3, or 1st Treatment Dose cannot be reported as Patient did not receive dose when the 1st Subsequent Treatment Dose has been reported with a date or as Date unknown.",

  ELREXFIO_INPATIENT_HOSP_MISSING:
    "WARNING: This patient was indicated to have at least one step-up dosing administration (e.g., Step-up dose 1, Step-up dose 2, 1st treatment dose) in an inpatient setting, yet no hospitalizations have been reported here. Please revise to provide the dates of hospitalizations related to Bispecific treatment administration or otherwise revise the setting of care of the step-up dosing phase administrations.",

  LINVO_INPATIENT_HOSP_MISSING:
    "WARNING: This patient was indicated to have at least one step-up dosing administration (e.g., Step-up dose 1, Step-up dose 2, Step-up dose 3, 1st treatment dose) in an inpatient setting, yet no hospitalizations have been reported here. Please revise to provide the dates of hospitalizations related to Bispecific treatment administration or otherwise revise the setting of care of the step-up dosing phase administrations.",

  Q37_ELREX_DOSAGE_EMPTY:
    "Please select the initial dosing strength for ELREXFIO.",
  Q37_ELREX_DOSAGE_OTHER_EMPTY: "Please specify the initial dosing strength.",

  q37SubsequentDoseConflict:
    "WARNING: this patient was indicated to have at least one administration after concluding the step-up dosing phase (e.g., a subsequent treatment dose administration) in Q36, yet the patient was indicated as not having completed the step-up dosing phase here. Please revise the response to the initial dosing frequency after index or otherwise revise the dosing phase of administrations in Q36, as needed.",

  Q38ElrexDateInvalid:
    "At least one of the dates of dose frequency reduction is invalid. Please ensure that all dates of dose frequency reduction are after the treatment initiation date and on or before the date of last dose administration for the treatment cohort.",

  specifyDosageFrequencyAndRange:
    "Please describe the dosing strength and ensure the entered value is between 0 and 50.",

  Q38FrequencyConflict:
    "WARNING: the initial dose frequency after step-up dosing is less than the dose frequency reported after the dose frequency reduction. Please revise such that the dose frequency after reduction is less than that immediately after step-up dosing or modify your response on the presence of a dose frequency reduction in Q37.",
  Q391ATocilizumabAdministrationDateEmty:
    "Please enter the date of tocilizumab administration (if known) or unknown otherwise",
  Q391AAdministrationDateOutOfRange:
    "Tocilizumab Administration Date must be between the Bispecifics/CAR-T initiation date and the start date of the subsequent line of therapy, and on or before the end of follow-up for the last LOT.",
  Q391ATocilizumabDateChainOutOfBound:
    "Date must be on or after the Bispecific/CAR-T index date, initiation date and the earliest 1st subsequent treatment dose in Q36, and on or before last administration date of Q26, LOT end date of Q26.2, subsequent LOT start date, and end of follow-up.",
  Q40DateOutOfRange:
    "The date must be on or after the Index Date and on or before the start date of next LOT (if applicable) or end of follow-up for the last LOT.",
  Q40FullChainOutOfRange:
    "Please ensure that the Bispecific/CAR-T Index Date is on or before the Bispecific/CAR-T Initiation Date, which is on or before the Date in Column [B], the Date of Last Administration reported in Column [D] of Q26 (if known), the End Date of LOT in Q26.2, the Start Date of Subsequent LOT (if reported), and the End of Follow-up.",

  //Q36 New Date Validations
  Q362L3LErrorMessage:
    "One or more dates are out of sequence. The latest dose administration date must be on or before the discontinuation date of the current LOT, which must be on or before the start date of the next LOT, and all must be on or before the end of follow-up.",
  // ========================================
  // Q38.1.A & Q38.2.A - DOSE CHANGES
  // ========================================
  // Column B validations
  ChangeTypeEmpty: "Please select type of change",
  ChangeTypeDoseFrequencyEmpty: "Please select frequency change type",
  ChangeTypeDoseStrengthEmpty: "Please select strength change type",

  // Column C validations
  ReasonOtherTextEmpty: "Please specify the other reason",
  Q38ReasonEmpty:
    "Please select at least one reason (if known) or unknown otherwise",
  Q38AEEmpty:
    "Please select at least one AE type (if known) or AE type unknown otherwise",
  Q38AENeurologicEmpty: "Please select at least one neurologic event",
  Q38AENeurologicOther: "Please specify other neurologic event",

  deathWarningQ20:
    "WARNING: you have indicated that at least 1 dose frequency and/or dose strength change was death however no date of death is reported in Q20. Please revise the reason for dose frequency/strength change to a reason besides death or otherwise add a date of death in Q20",

  // Column D & E validations
  PatternBeforeFrequencyEmpty: "Please provide dose frequency before change",
  PatternBeforeStrengthEmpty: "Please provide dose strength before change",
  PatternAfterFrequencyEmpty: "Please provide dose frequency after change",
  PatternAfterStrengthEmpty: "Please provide dose strength after change",
  FrequencyIncreaseConflict:
    "Frequency after change must be greater than before",
  FrequencyDecreaseConflict: "Frequency after change must be less than before",
  StrengthIncreaseConflict: "Strength after change must be greater than before",
  StrengthDecreaseConflict: "Strength after change must be less than before",

  // Column F validations
  DateChangeRdEmpty: "Please select date option",
  DateChangeEmpty: "Please provide date of change",
  DateChangeOutOfBound:
    "Date must be on or after the Bispecific/CAR-T index date, initiation date and the earliest 1st subsequent treatment dose in Q36, and on or before last administration date of Q26, LOT end date of Q26.2, subsequent LOT start date, and end of follow-up.",

  // Warnings
  Q381AWarningUnk:
    "WARNING: dose frequency or dose strength has been listed as unknown for at least one reported change. Please attempt to infer the dose frequency or strength both before and after the change based on information within the patient chart. Only use the unknown option if there is truly no information reported on the dose frequency/strength (note that directionality of change is required).",
  Q381AChainMismatchWarning:
    "WARNING: for at least one dose frequency or dose strength change, the pattern after change does not match the pattern before the next chronological change of the same type. Please confirm the values and dates entered are correct and revise accordingly, as needed.",
  //AUTO-009 - Q36 reports more than one 1st subsequent treatment dose and the
  //first change's "Pattern before change" matches none of them.
  Q381AQ36PatternBeforeMismatch:
    "The first dose frequency or dose strength change reports a “Pattern before change” that differs from the 1st subsequent treatment dose provided in Q36. It is expected that the initial dose frequency and dose strength in these questions match before any changes. Please reconcile with Q36 or add any missing dose changes.",
  Q382AWarningUnk:
    "WARNING: at least one date has been listed as unknown for at least one dose interruption episode. Please attempt to infer the dose interruption start and end dates based on information within the patient chart.",

  frequencyPatternEmpty: "Please select frequency pattern",
  frequencyRange: "Please enter frequency range between 1 and 20",
  strengthPatternEmpty: "Please select strength pattern",
  GeneralDateEmpty: "Please enter the date (if known) or unknown otherwise",
  patternBothUnknownWarning:
    "WARNING: at least one date has been listed as unknown for at least one dose interruption episode. Please attempt to infer the dose interruption start and end dates based on information within the patient chart.",

  WarningForIVIGQ401a:
    "WARNING: you have indicated specific reasons for receiving IGRT in Q40 yet these same reasons are not listed at least once across all administrations of IGRT in Q41.1.B. Please confirm all reasons for IGRT administrations in both questions.",

  //Q40.1.B
  Q401aSelect_RdHard: "Please choose one of the provided options",
  Q401aDateAdm_Hard:
    "Please enter the Date of IGRT administration date (if known) or unknown otherwise",
  Q401aFrequencyEmptyHard: "Please enter dosing frequency range",
  Q401aSelectCheckbox_RdHard:
    "Please choose at least one of the provided options",
  Q401aDosageEmptyHardG: "Please enter dosage value g between 1 to 200",
  Q401aDosageEmptyHardMG: "Please enter dosage value mg/kg between 1 to 2000",
  Q401aBodyWeightEmptyHardKg:
    "Please enter body weight value kg between 1 to 630 (up to 2 decimals permitted) or otherwise specify “Unknown” ",
  Q401aBodyWeightEmptyHardLbs:
    "Please enter body weight value lbs between 1 to 1400 (up to 2 decimals permitted) or otherwise specify “Unknown” ",
  Q401aDateWeight_Hard:
    "Please enter the Date of weight assessment date (if known) or unknown otherwise",

  DateBeforeEOFAfterIndex:
    "The date must be on or after the Index Date and on or before the start date of next LOT (if applicable) or end of follow-up for the last LOT.",

  Q402BDateBeforeEOFAfterIndex91:
    "The date must be on or after the Index Date - 91 days and on or before Index Date + 7 days, the start date of next LOT (if applicable), and the end of follow-up date for the last LOT.",

  Q403BDateRangeError:
    "The date must be on or after the Index Date - 91 days and Q40 date - 91 days and on or before the start date of next LOT (if applicable), and the end of follow-up date for the last LOT.",

  //Q40.2.B
  Q402aSelect_RdHard: "Please choose one of the provided options",
  Q402aIggDateAdm_Hard:
    "Please enter the Date of IgG administration date (if known) or unknown otherwise",
  Q402aLevelRangeHardGL: "Please enter dosage value g/L between 1 to 50",
  Q402aLevelRangeHardMG: "Please enter dosage value mg/dL between 1 to 5000",

  //Q40.2.C
  Q402cSelect_RdHard: "Please choose one of the provided options",
  Q402cIggDateAdm_Hard:
    "Please enter the date of IgG assessment (if known) or unknown otherwise",
  Q402cLevelBucketEmptyHard: "Please choose one of the provided options",
  Q402cLevelRangeHardMG: "Please enter dosage value mg/dL between 1 to 5000",
  Q402cLevelRangeHardGL: "Please enter dosage value g/L between 1 to 50",
  Q402cDateOutOfRange:
    "The date must fall within the target assessment window shown above and on or before the start date of the next LOT (if applicable) or end of follow-up.",
  Q402cRow1NotEarliest:
    "The IgG assessment closest to the start of bispecific treatment must be on or before all other reported IgG assessment dates in this table. Please revise accordingly.",
  Q402cRow2ThresholdConflict:
    "WARNING: at least one row reports an IgG level of 400-500 mg/dL or >500 mg/dL, but the highest IgG level reported is not consistent with this. Please revise accordingly.",
  Q402cDatesNotChronological:
    "WARNING: the dates of IgG assessment are not in chronological order across rows. Please confirm the dates entered are correct and revise accordingly.",
};

export const hyperlinkTextQ36Elrexfio = `
<div>
  <p style="text-align: left; font-weight: normal;">
    Step-up and treatment dosing for <b>ELREXFIO<sup>TM</sup> (elranatamab-bcmm)</b>
    should be based on the recommended dosing schedule according to the prescription label.
    (dosing information below up-to-date as of November 5<sup>th</sup>, 2025):
  </p>

  <table border="1" style="width:100%; border-collapse: collapse; table-layout: fixed;">
    <tr>
      <td colspan="4" style="border: 1px solid black; text-align: center;">
        ELREXFIO<sup>TM</sup> Recommended Dosing Schedule
      </td>
    </tr>

    <tr>
      <td style="border: 1px solid black; text-align: center;">Dosing Schedule</td>
      <td style="border: 1px solid black; text-align: center;">Day</td>
      <td style="border: 1px solid black; text-align: center;">Dose</td>
      <td style="border: 1px solid black; text-align: center;">Amount</td>
    </tr>

    <!-- Step-up dosing schedule -->
    <tr>
      <td rowspan="3" style="border: 1px solid black; text-align: center;">
        Step-up dosing schedule
      </td>
      <td style="border: 1px solid black; text-align: center;">Day 1</td>
      <td style="border: 1px solid black; text-align: center;">Step-up dose 1</td>
      <td style="border: 1px solid black; text-align: center;">12 mg</td>
    </tr>

    <tr>
      <td style="border: 1px solid black; text-align: center;">Day 4</td>
      <td style="border: 1px solid black; text-align: center;">Step-up dose 2</td>
      <td style="border: 1px solid black; text-align: center;">32 mg</td>
    </tr>

    <tr>
      <td style="border: 1px solid black; text-align: center;">Day 8</td>
      <td style="border: 1px solid black; text-align: center;">
        1<sup>st</sup> treatment dose
      </td>
      <td style="border: 1px solid black; text-align: center;">76 mg</td>
    </tr>

    <!-- Treatment dosing schedule -->
    <tr>
      <td rowspan="3" style="border: 1px solid black; text-align: center;">
        Treatment dosing schedule
      </td>
      <td style="border: 1px solid black; text-align: center;">
        Weekly: One week after first treatment dose and weekly thereafter through Week 24
      </td>
      <td rowspan="3" style="border: 1px solid black; text-align: center;">
        Subsequent treatment doses
      </td>
      <td rowspan="3" style="border: 1px solid black; text-align: center;">
        76 mg
      </td>
    </tr>

    <tr>
      <td style="border: 1px solid black; text-align: center;">
        Biweekly: Week 25 and every 2 weeks thereafter through Week 48<sup>f</sup>
      </td>
    </tr>

    <tr>
      <td style="border: 1px solid black; text-align: center;">
        Monthly: Week 49 and every 4 weeks thereafter<sup>g</sup>
      </td>
    </tr>
  </table>

   <p style="text-align: left; font-size: 12px; font-weight: normal;">
    <sup>a</sup>Based on actual body weight.<br/>
    <sup>b</sup>Dose may be administered between 2-4 days after the previous dose and may be given up to 7 days after the previous dose to allow for resolution of adverse reactions<br/>
    <sup>c</sup>Maintain a minimum of 6 days between weekly doses<br/>
    <sup>d</sup>Dose may be administered between 2 to 7 days after step-up dose 3.<br/>
    <sup>e</sup>Maintain a minimum of 12 days between biweekly (every 2 weeks) doses.<br/>
    <sup>f</sup>Responders only Week 25 onward.<br/>
    <sup>g</sup>In patients who have maintained the response following 24 weeks of treatment at the biweekly dosing schedule.<br/>
  </p>
</div>
`;

export const hyperlinkTextQ36Linvoseltamab = `
<div>
  <p style="text-align: left; font-weight: normal;">
    Step-up and treatment dosing for <b>LYNOZYFIC<sup>TM</sup> (linvoseltamab)</b>
    should be based on the recommended dosing schedule according to the prescription label.
    (Dosing information below is up to date as of <b>November 5<sup>th</sup>, 2025</b>):
  </p>

  <table border="1" style="width:100%; border-collapse: collapse; table-layout: fixed;">
    <tr>
      <td colspan="4" style="border: 1px solid black; text-align: center; font-weight: bold;">
        LYNOZYFIC<sup>TM</sup> Recommended Dosing Schedule
      </td>
    </tr>

    <tr>
      <td style="border: 1px solid black; text-align: center; font-weight: bold;">Dosing Schedule</td>
      <td style="border: 1px solid black; text-align: center; font-weight: bold;">Day / Timing</td>
      <td style="border: 1px solid black; text-align: center; font-weight: bold;">Dose</td>
      <td style="border: 1px solid black; text-align: center; font-weight: bold;">Amount</td>
    </tr>

    <!-- Step-up dosing schedule -->
    <tr>
      <td rowspan="3" style="border: 1px solid black; text-align: center;">
        Step-up dosing schedule
      </td>
      <td style="border: 1px solid black; text-align: center;">Day 1</td>
      <td style="border: 1px solid black; text-align: center;">Step-up dose 1</td>
      <td style="border: 1px solid black; text-align: center;">5 mg</td>
    </tr>

    <tr>
      <td style="border: 1px solid black; text-align: center;">Day 8</td>
      <td style="border: 1px solid black; text-align: center;">Step-up dose 2</td>
      <td style="border: 1px solid black; text-align: center;">25 mg</td>
    </tr>

    <tr>
      <td style="border: 1px solid black; text-align: center;">Day 15</td>
      <td style="border: 1px solid black; text-align: center;">1<sup>st</sup> treatment dose</td>
      <td style="border: 1px solid black; text-align: center;">200 mg</td>
    </tr>

    <!-- Treatment dosing schedule -->
    <tr>
      <td rowspan="3" style="border: 1px solid black; text-align: center;">
        Treatment dosing schedule
      </td>
      <td style="border: 1px solid black; text-align: left; padding: 4px;">
        <b>Weekly:</b> one week after Day 15 treatment dose and once weekly from Week 4 to Week 13 for 10 treatment doses
      </td>
      <td rowspan="3" style="border: 1px solid black; text-align: center;">
        Subsequent treatment doses
      </td>
      <td rowspan="3" style="border: 1px solid black; text-align: center;">
        200 mg
      </td>
    </tr>

    <tr>
      <td style="border: 1px solid black; text-align: left; padding: 4px;">
        <b>Biweekly:</b> 
 Week 14 and every 2 weeks thereafter 

Among patients who have achieved and maintained VGPR or better at or after Week 24 and received at least 17 doses of 200mg 


      </td>
    </tr>

    <tr>
      <td style="border: 1px solid black; text-align: left; padding: 4px;">
        <b>Monthly:</b>at Week 24 or after and every 4 weeks thereafter 
      </td>
    </tr>
  </table>

   <p style="text-align: left; font-size: 12px; font-weight: normal;">
    <sup>a</sup>Based on actual body weight.<br/>
    <sup>b</sup>Dose may be administered between 2-4 days after the previous dose and may be given up to 7 days after the previous dose to allow for resolution of adverse reactions<br/>
    <sup>c</sup>Maintain a minimum of 6 days between weekly doses<br/>
    <sup>d</sup>Dose may be administered between 2 to 7 days after step-up dose 3.<br/>
    <sup>e</sup>Maintain a minimum of 12 days between biweekly (every 2 weeks) doses.<br/>
    <sup>f</sup>Responders only Week 25 onward.<br/>
    <sup>g</sup>In patients who have maintained the response following 24 weeks of treatment at the biweekly dosing schedule.<br/>
  </p>
</div>
`;
